// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

:root, [data-theme] {
  color: hsl(var(--coreui-foreground));
  background-color: hsl(var(--coreui-background));
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.tw-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.tw-pointer-events-none {
  pointer-events: none;
}
.tw-pointer-events-auto {
  pointer-events: auto;
}
.tw-static {
  position: static;
}
.tw-fixed {
  position: fixed;
}
.tw-absolute {
  position: absolute;
}
.tw-relative {
  position: relative;
}
.tw-sticky {
  position: sticky;
}
.tw-inset-0 {
  inset: 0px;
}
.tw-inset-x-0 {
  left: 0px;
  right: 0px;
}
.tw-bottom-0 {
  bottom: 0px;
}
.tw-bottom-\\[10\\%\\] {
  bottom: 10%;
}
.tw-bottom-\\[5\\%\\] {
  bottom: 5%;
}
.tw-left-0 {
  left: 0px;
}
.tw-left-1 {
  left: 0.25rem;
}
.tw-left-1\\.5 {
  left: 0.375rem;
}
.tw-left-1\\/2 {
  left: 50%;
}
.tw-left-2 {
  left: 0.5rem;
}
.tw-left-3 {
  left: 0.75rem;
}
.tw-left-\\[10\\%\\] {
  left: 10%;
}
.tw-left-\\[5\\%\\] {
  left: 5%;
}
.tw-right-1 {
  right: 0.25rem;
}
.tw-right-1\\.5 {
  right: 0.375rem;
}
.tw-right-3 {
  right: 0.75rem;
}
.tw-right-\\[10\\%\\] {
  right: 10%;
}
.tw-right-\\[5\\%\\] {
  right: 5%;
}
.tw-top-0 {
  top: 0px;
}
.tw-top-1 {
  top: 0.25rem;
}
.tw-top-1\\/2 {
  top: 50%;
}
.tw-top-\\[10\\%\\] {
  top: 10%;
}
.tw-top-\\[5\\%\\] {
  top: 5%;
}
.tw-top-\\[calc\\(100\\%_\\+_2px\\)\\] {
  top: calc(100% + 2px);
}
.tw-top-\\[var\\(--navbar-height\\)\\] {
  top: var(--navbar-height);
}
.tw--z-30 {
  z-index: -30;
}
.tw-z-0 {
  z-index: 0;
}
.tw-z-10 {
  z-index: 10;
}
.tw-z-20 {
  z-index: 20;
}
.tw-z-30 {
  z-index: 30;
}
.tw-z-40 {
  z-index: 40;
}
.tw-z-50 {
  z-index: 50;
}
.tw--m-2 {
  margin: -0.5rem;
}
.tw--m-2\\.5 {
  margin: -0.625rem;
}
.tw-m-0 {
  margin: 0px;
}
.tw--mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.tw-mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.tw-mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.tw-mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.tw-mx-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-left: calc((1.25rem - 0.25rem) / 2);
  margin-right: calc((1.25rem - 0.25rem) / 2);
}
.tw-mx-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-left: calc((1.5rem - 0.75rem) / 2);
  margin-right: calc((1.5rem - 0.75rem) / 2);
}
.tw-mx-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-left: calc((1.75rem - 1.25rem) / 2);
  margin-right: calc((1.75rem - 1.25rem) / 2);
}
.tw-my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.tw-my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.tw-my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.tw-my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.tw-my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.tw-my-\\[calc\\(\\(theme\\(spacing\\.5\\)-theme\\(spacing\\.1\\)\\)\\/2\\)\\] {
  margin-top: calc((1.25rem - 0.25rem) / 2);
  margin-bottom: calc((1.25rem - 0.25rem) / 2);
}
.tw-my-\\[calc\\(\\(theme\\(spacing\\.6\\)-theme\\(spacing\\.3\\)\\)\\/2\\)\\] {
  margin-top: calc((1.5rem - 0.75rem) / 2);
  margin-bottom: calc((1.5rem - 0.75rem) / 2);
}
.tw-my-\\[calc\\(\\(theme\\(spacing\\.7\\)-theme\\(spacing\\.5\\)\\)\\/2\\)\\] {
  margin-top: calc((1.75rem - 1.25rem) / 2);
  margin-bottom: calc((1.75rem - 1.25rem) / 2);
}
.tw-my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.tw--mr-2 {
  margin-right: -0.5rem;
}
.tw--ms-2 {
  margin-inline-start: -0.5rem;
}
.tw-mb-1 {
  margin-bottom: 0.25rem;
}
.tw-mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.tw-mb-2 {
  margin-bottom: 0.5rem;
}
.tw-mb-5 {
  margin-bottom: 1.25rem;
}
.tw-mb-px {
  margin-bottom: 1px;
}
.tw-ml-1 {
  margin-left: 0.25rem;
}
.tw-ml-2 {
  margin-left: 0.5rem;
}
.tw-mr-2 {
  margin-right: 0.5rem;
}
.tw-mt-0 {
  margin-top: 0px;
}
.tw-mt-0\\.5 {
  margin-top: 0.125rem;
}
.tw-mt-1 {
  margin-top: 0.25rem;
}
.tw-mt-2 {
  margin-top: 0.5rem;
}
.tw-mt-3 {
  margin-top: 0.75rem;
}
.tw-box-border {
  box-sizing: border-box;
}
.tw-box-content {
  box-sizing: content-box;
}
.tw-line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tw-block {
  display: block;
}
.tw-inline-block {
  display: inline-block;
}
.tw-flex {
  display: flex;
}
.tw-inline-flex {
  display: inline-flex;
}
.tw-table {
  display: table;
}
.tw-inline-grid {
  display: inline-grid;
}
.tw-hidden {
  display: none;
}
.\\!tw-h-auto {
  height: auto !important;
}
.tw-h-1 {
  height: 0.25rem;
}
.tw-h-1\\.5 {
  height: 0.375rem;
}
.tw-h-10 {
  height: 2.5rem;
}
.tw-h-12 {
  height: 3rem;
}
.tw-h-14 {
  height: 3.5rem;
}
.tw-h-16 {
  height: 4rem;
}
.tw-h-2 {
  height: 0.5rem;
}
.tw-h-2\\.5 {
  height: 0.625rem;
}
.tw-h-3 {
  height: 0.75rem;
}
.tw-h-3\\.5 {
  height: 0.875rem;
}
.tw-h-4 {
  height: 1rem;
}
.tw-h-40 {
  height: 10rem;
}
.tw-h-5 {
  height: 1.25rem;
}
.tw-h-6 {
  height: 1.5rem;
}
.tw-h-7 {
  height: 1.75rem;
}
.tw-h-8 {
  height: 2rem;
}
.tw-h-9 {
  height: 2.25rem;
}
.tw-h-\\[100dvh\\] {
  height: 100dvh;
}
.tw-h-\\[2px\\] {
  height: 2px;
}
.tw-h-\\[calc\\(100dvh_-_var\\(--navbar-height\\)_-_1px\\)\\] {
  height: calc(100dvh - var(--navbar-height) - 1px);
}
.tw-h-\\[var\\(--navbar-height\\)\\] {
  height: var(--navbar-height);
}
.tw-h-\\[var\\(--picker-height\\)\\] {
  height: var(--picker-height);
}
.tw-h-auto {
  height: auto;
}
.tw-h-divider {
  height: var(--coreui-divider-weight);
}
.tw-h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.tw-h-full {
  height: 100%;
}
.tw-h-px {
  height: 1px;
}
.tw-h-screen {
  height: 100vh;
}
.tw-max-h-48 {
  max-height: 12rem;
}
.tw-max-h-64 {
  max-height: 16rem;
}
.tw-max-h-\\[calc\\(100\\%_-_7\\.5rem\\)\\] {
  max-height: calc(100% - 7.5rem);
}
.tw-min-h-0 {
  min-height: 0px;
}
.tw-min-h-10 {
  min-height: 2.5rem;
}
.tw-min-h-12 {
  min-height: 3rem;
}
.tw-min-h-14 {
  min-height: 3.5rem;
}
.tw-min-h-16 {
  min-height: 4rem;
}
.tw-min-h-3 {
  min-height: 0.75rem;
}
.tw-min-h-3\\.5 {
  min-height: 0.875rem;
}
.tw-min-h-4 {
  min-height: 1rem;
}
.tw-min-h-5 {
  min-height: 1.25rem;
}
.tw-min-h-6 {
  min-height: 1.5rem;
}
.tw-min-h-7 {
  min-height: 1.75rem;
}
.tw-min-h-8 {
  min-height: 2rem;
}
.tw-min-h-\\[27px\\] {
  min-height: 27px;
}
.tw-min-h-\\[32px\\] {
  min-height: 32px;
}
.tw-w-1 {
  width: 0.25rem;
}
.tw-w-1\\.5 {
  width: 0.375rem;
}
.tw-w-10 {
  width: 2.5rem;
}
.tw-w-12 {
  width: 3rem;
}
.tw-w-14 {
  width: 3.5rem;
}
.tw-w-2 {
  width: 0.5rem;
}
.tw-w-2\\.5 {
  width: 0.625rem;
}
.tw-w-3 {
  width: 0.75rem;
}
.tw-w-3\\.5 {
  width: 0.875rem;
}
.tw-w-4 {
  width: 1rem;
}
.tw-w-5 {
  width: 1.25rem;
}
.tw-w-6 {
  width: 1.5rem;
}
.tw-w-7 {
  width: 1.75rem;
}
.tw-w-8 {
  width: 2rem;
}
.tw-w-9 {
  width: 2.25rem;
}
.tw-w-\\[80\\%\\] {
  width: 80%;
}
.tw-w-\\[calc\\(100\\%_-_16px\\)\\] {
  width: calc(100% - 16px);
}
.tw-w-\\[calc\\(100\\%_-_theme\\(spacing\\.6\\)\\)\\] {
  width: calc(100% - 1.5rem);
}
.tw-w-\\[calc\\(var\\(--visible-months\\)_\\*_var\\(--calendar-width\\)\\)\\] {
  width: calc(var(--visible-months) * var(--calendar-width));
}
.tw-w-\\[var\\(--calendar-width\\)\\] {
  width: var(--calendar-width);
}
.tw-w-auto {
  width: auto;
}
.tw-w-divider {
  width: var(--coreui-divider-weight);
}
.tw-w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.tw-w-full {
  width: 100%;
}
.tw-w-max {
  width: max-content;
}
.tw-w-px {
  width: 1px;
}
.tw-w-screen {
  width: 100vw;
}
.tw-min-w-0 {
  min-width: 0px;
}
.tw-min-w-10 {
  min-width: 2.5rem;
}
.tw-min-w-12 {
  min-width: 3rem;
}
.tw-min-w-16 {
  min-width: 4rem;
}
.tw-min-w-20 {
  min-width: 5rem;
}
.tw-min-w-24 {
  min-width: 6rem;
}
.tw-min-w-3 {
  min-width: 0.75rem;
}
.tw-min-w-3\\.5 {
  min-width: 0.875rem;
}
.tw-min-w-4 {
  min-width: 1rem;
}
.tw-min-w-5 {
  min-width: 1.25rem;
}
.tw-min-w-6 {
  min-width: 1.5rem;
}
.tw-min-w-7 {
  min-width: 1.75rem;
}
.tw-min-w-8 {
  min-width: 2rem;
}
.tw-min-w-9 {
  min-width: 2.25rem;
}
.tw-min-w-\\[200px\\] {
  min-width: 200px;
}
.tw-min-w-full {
  min-width: 100%;
}
.tw-min-w-max {
  min-width: max-content;
}
.tw-min-w-min {
  min-width: min-content;
}
.tw-max-w-2xl {
  max-width: 42rem;
}
.tw-max-w-3xl {
  max-width: 48rem;
}
.tw-max-w-4xl {
  max-width: 56rem;
}
.tw-max-w-5xl {
  max-width: 64rem;
}
.tw-max-w-\\[1024px\\] {
  max-width: 1024px;
}
.tw-max-w-\\[1280px\\] {
  max-width: 1280px;
}
.tw-max-w-\\[1536px\\] {
  max-width: 1536px;
}
.tw-max-w-\\[270px\\] {
  max-width: 270px;
}
.tw-max-w-\\[640px\\] {
  max-width: 640px;
}
.tw-max-w-\\[768px\\] {
  max-width: 768px;
}
.tw-max-w-\\[85\\%\\] {
  max-width: 85%;
}
.tw-max-w-\\[90\\%\\] {
  max-width: 90%;
}
.tw-max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.tw-max-w-full {
  max-width: 100%;
}
.tw-max-w-lg {
  max-width: 32rem;
}
.tw-max-w-md {
  max-width: 28rem;
}
.tw-max-w-sm {
  max-width: 24rem;
}
.tw-max-w-xl {
  max-width: 36rem;
}
.tw-max-w-xs {
  max-width: 20rem;
}
.tw-flex-1 {
  flex: 1 1;
}
.tw-flex-auto {
  flex: 1 1 auto;
}
.tw-flex-initial {
  flex: 0 1 auto;
}
.tw-flex-none {
  flex: none;
}
.tw-flex-shrink-0 {
  flex-shrink: 0;
}
.tw-shrink-0 {
  flex-shrink: 0;
}
.tw-flex-grow {
  flex-grow: 1;
}
.tw-basis-0 {
  flex-basis: 0px;
}
.tw-table-auto {
  table-layout: auto;
}
.tw-table-fixed {
  table-layout: fixed;
}
.tw-border-collapse {
  border-collapse: collapse;
}
.tw-origin-center {
  transform-origin: center;
}
.tw-origin-left {
  transform-origin: left;
}
.tw-origin-right {
  transform-origin: right;
}
.tw-origin-top {
  transform-origin: top;
}
.tw-origin-top-left {
  transform-origin: top left;
}
.tw--translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw--translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-indeterminate-bar {

  0% {
    transform: translateX(-50%) scaleX(0.2);
  }

  100% {
    transform: translateX(100%) scaleX(1);
  }
}
.tw-animate-indeterminate-bar {
  animation: tw-indeterminate-bar 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite normal none running;
}
.tw-animate-none {
  animation: none;
}
@keyframes tw-spin {

  to {
    transform: rotate(360deg);
  }
}
.tw-animate-spin {
  animation: tw-spin 1s linear infinite;
}
@keyframes tw-spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.tw-animate-spinner-ease-spin {
  animation: tw-spinner-spin 0.8s ease infinite;
}
@keyframes tw-spinner-spin {

  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.tw-animate-spinner-linear-spin {
  animation: tw-spinner-spin 0.8s linear infinite;
}
.tw-cursor-default {
  cursor: default;
}
.tw-cursor-grab {
  cursor: grab;
}
.tw-cursor-not-allowed {
  cursor: not-allowed;
}
.tw-cursor-pointer {
  cursor: pointer;
}
.tw-cursor-text {
  cursor: text;
}
.tw-touch-none {
  touch-action: none;
}
.tw-select-none {
  -webkit-user-select: none;
          user-select: none;
}
.tw-resize-none {
  resize: none;
}
.tw-snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.tw-snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.tw-snap-center {
  scroll-snap-align: center;
}
.tw-scroll-py-6 {
  scroll-padding-top: 1.5rem;
  scroll-padding-bottom: 1.5rem;
}
.tw-list-decimal {
  list-style-type: decimal;
}
.tw-list-disc {
  list-style-type: disc;
}
.tw-list-none {
  list-style-type: none;
}
.tw-appearance-none {
  appearance: none;
}
.tw-grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.tw-flex-row {
  flex-direction: row;
}
.tw-flex-row-reverse {
  flex-direction: row-reverse;
}
.tw-flex-col {
  flex-direction: column;
}
.tw-flex-col-reverse {
  flex-direction: column-reverse;
}
.tw-flex-wrap {
  flex-wrap: wrap;
}
.tw-flex-nowrap {
  flex-wrap: nowrap;
}
.tw-place-content-center {
  place-content: center;
}
.tw-items-start {
  align-items: flex-start;
}
.tw-items-end {
  align-items: flex-end;
}
.tw-items-center {
  align-items: center;
}
.tw-justify-start {
  justify-content: flex-start;
}
.tw-justify-end {
  justify-content: flex-end;
}
.tw-justify-center {
  justify-content: center;
}
.tw-justify-between {
  justify-content: space-between;
}
.\\!tw-gap-0 {
  gap: 0px !important;
}
.tw-gap-0 {
  gap: 0px;
}
.tw-gap-0\\.5 {
  gap: 0.125rem;
}
.tw-gap-1 {
  gap: 0.25rem;
}
.tw-gap-1\\.5 {
  gap: 0.375rem;
}
.tw-gap-2 {
  gap: 0.5rem;
}
.tw-gap-3 {
  gap: 0.75rem;
}
.tw-gap-4 {
  gap: 1rem;
}
.tw-gap-x-0 {
  column-gap: 0px;
}
.tw-gap-x-0\\.5 {
  column-gap: 0.125rem;
}
.tw-gap-x-2 {
  column-gap: 0.5rem;
}
.tw-gap-x-6 {
  column-gap: 1.5rem;
}
.tw-gap-y-1 {
  row-gap: 0.25rem;
}
.tw-gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.tw-gap-y-2 {
  row-gap: 0.5rem;
}
.tw-space-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}
.tw-space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.tw-self-center {
  align-self: center;
}
.tw-overflow-auto {
  overflow: auto;
}
.tw-overflow-hidden {
  overflow: hidden;
}
.tw-overflow-visible {
  overflow: visible;
}
.tw-overflow-x-auto {
  overflow-x: auto;
}
.tw-overflow-y-auto {
  overflow-y: auto;
}
.tw-overflow-y-hidden {
  overflow-y: hidden;
}
.tw-overflow-x-scroll {
  overflow-x: scroll;
}
.tw-overflow-y-scroll {
  overflow-y: scroll;
}
.tw-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tw-text-ellipsis {
  text-overflow: ellipsis;
}
.tw-whitespace-normal {
  white-space: normal;
}
.tw-whitespace-nowrap {
  white-space: nowrap;
}
.tw-whitespace-pre-wrap {
  white-space: pre-wrap;
}
.tw-break-words {
  overflow-wrap: break-word;
}
.\\!tw-rounded-none {
  border-radius: 0px !important;
}
.tw-rounded {
  border-radius: 0.25rem;
}
.tw-rounded-2xl {
  border-radius: 1rem;
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/1\\.5\\)\\] {
  border-radius: calc(var(--coreui-radius-large) / 1.5);
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\] {
  border-radius: calc(var(--coreui-radius-medium) * 0.5);
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\] {
  border-radius: calc(var(--coreui-radius-medium) * 0.6);
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\] {
  border-radius: calc(var(--coreui-radius-medium) * 0.7);
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/2\\)\\] {
  border-radius: calc(var(--coreui-radius-medium) / 2);
}
.tw-rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/2\\)\\] {
  border-radius: calc(var(--coreui-radius-small) / 2);
}
.tw-rounded-full {
  border-radius: 9999px;
}
.tw-rounded-large {
  border-radius: var(--coreui-radius-large);
}
.tw-rounded-lg {
  border-radius: 0.5rem;
}
.tw-rounded-md {
  border-radius: 0.375rem;
}
.tw-rounded-medium {
  border-radius: var(--coreui-radius-medium);
}
.tw-rounded-none {
  border-radius: 0px;
}
.tw-rounded-small {
  border-radius: var(--coreui-radius-small);
}
.\\!tw-rounded-l-none {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!tw-rounded-r-none {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.tw-rounded-b-large {
  border-bottom-right-radius: var(--coreui-radius-large);
  border-bottom-left-radius: var(--coreui-radius-large);
}
.tw-rounded-b-medium {
  border-bottom-right-radius: var(--coreui-radius-medium);
  border-bottom-left-radius: var(--coreui-radius-medium);
}
.tw-rounded-b-small {
  border-bottom-right-radius: var(--coreui-radius-small);
  border-bottom-left-radius: var(--coreui-radius-small);
}
.tw-rounded-t-large {
  border-top-left-radius: var(--coreui-radius-large);
  border-top-right-radius: var(--coreui-radius-large);
}
.tw-rounded-t-medium {
  border-top-left-radius: var(--coreui-radius-medium);
  border-top-right-radius: var(--coreui-radius-medium);
}
.tw-rounded-t-small {
  border-top-left-radius: var(--coreui-radius-small);
  border-top-right-radius: var(--coreui-radius-small);
}
.tw-rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}
.tw-rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}
.tw-border {
  border-width: 1px;
}
.tw-border-0 {
  border-width: 0px;
}
.tw-border-2 {
  border-width: 2px;
}
.tw-border-3 {
  border-width: 3px;
}
.tw-border-medium {
  border-width: var(--coreui-border-width-medium);
}
.tw-border-small {
  border-width: var(--coreui-border-width-small);
}
.tw-border-x-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-left-width: calc(1.25rem / 2);
  border-right-width: calc(1.25rem / 2);
}
.tw-border-x-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-left-width: calc(1.5rem / 2);
  border-right-width: calc(1.5rem / 2);
}
.tw-border-x-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-left-width: calc(1.75rem / 2);
  border-right-width: calc(1.75rem / 2);
}
.tw-border-y-\\[calc\\(theme\\(spacing\\.5\\)\\/2\\)\\] {
  border-top-width: calc(1.25rem / 2);
  border-bottom-width: calc(1.25rem / 2);
}
.tw-border-y-\\[calc\\(theme\\(spacing\\.6\\)\\/2\\)\\] {
  border-top-width: calc(1.5rem / 2);
  border-bottom-width: calc(1.5rem / 2);
}
.tw-border-y-\\[calc\\(theme\\(spacing\\.7\\)\\/2\\)\\] {
  border-top-width: calc(1.75rem / 2);
  border-bottom-width: calc(1.75rem / 2);
}
.tw-border-b {
  border-bottom-width: 1px;
}
.tw-border-b-medium {
  border-bottom-width: var(--coreui-border-width-medium);
}
.tw-border-l-2 {
  border-left-width: 2px;
}
.tw-border-solid {
  border-style: solid;
}
.tw-border-dotted {
  border-style: dotted;
}
.tw-border-none {
  border-style: none;
}
.\\!tw-border-danger {
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 45 32 / var(--tw-border-opacity)) !important;
}
.tw-border-accent {
  border-color: hsl(var(--accent));
}
.tw-border-accent\\/60 {
  border-color: hsl(var(--accent) / 0.6);
}
.tw-border-background {
  border-color: hsl(var(--background));
}
.tw-border-border {
  border-color: hsl(var(--border));
}
.tw-border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-border-default {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.tw-border-default-200 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-border-opacity)));
}
.tw-border-default-300 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-border-opacity)));
}
.tw-border-destructive\\/60 {
  border-color: hsl(var(--destructive) / 0.6);
}
.tw-border-divider {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-divider) / var(--coreui-divider-opacity, var(--tw-border-opacity)));
}
.tw-border-emerald-700\\/50 {
  border-color: rgb(4 120 87 / 0.5);
}
.tw-border-foreground {
  border-color: hsl(var(--foreground));
}
.tw-border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.tw-border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.tw-border-success {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.tw-border-transparent {
  border-color: transparent;
}
.tw-border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.tw-border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.tw-border-y-transparent {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.tw-border-b-current {
  border-bottom-color: currentColor;
}
.tw-border-b-danger {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-border-b-default {
  --tw-border-opacity: 1;
  border-bottom-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.tw-border-b-foreground {
  border-bottom-color: hsl(var(--foreground));
}
.tw-border-b-primary {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.tw-border-b-secondary {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.tw-border-b-success {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.tw-border-b-warning {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.tw-border-b-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.tw-border-l-transparent {
  border-left-color: transparent;
}
.tw-border-r-transparent {
  border-right-color: transparent;
}
.tw-border-s-danger {
  --tw-border-opacity: 1;
  border-inline-start-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-border-s-foreground {
  border-inline-start-color: hsl(var(--foreground));
}
.tw-border-s-primary {
  --tw-border-opacity: 1;
  border-inline-start-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.tw-border-s-secondary {
  --tw-border-opacity: 1;
  border-inline-start-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.tw-border-s-success {
  --tw-border-opacity: 1;
  border-inline-start-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.tw-border-s-warning {
  --tw-border-opacity: 1;
  border-inline-start-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.tw-border-t-transparent {
  border-top-color: transparent;
}
.tw-bg-accent {
  background-color: hsl(var(--accent));
}
.tw-bg-accent\\/10 {
  background-color: hsl(var(--accent) / 0.1);
}
.tw-bg-background {
  background-color: hsl(var(--background));
}
.tw-bg-background\\/10 {
  background-color: hsl(var(--background) / 0.1);
}
.tw-bg-background\\/70 {
  background-color: hsl(var(--background) / 0.7);
}
.tw-bg-background\\/80 {
  background-color: hsl(var(--background) / 0.8);
}
.tw-bg-card {
  background-color: hsl(var(--card));
}
.tw-bg-content1 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content1) / var(--coreui-content1-opacity, var(--tw-bg-opacity)));
}
.tw-bg-content3 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content3) / var(--coreui-content3-opacity, var(--tw-bg-opacity)));
}
.tw-bg-copilot-primary {
  background-color: hsl(var(--primary));
}
.tw-bg-current {
  background-color: currentColor;
}
.tw-bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.tw-bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.tw-bg-danger\\/20 {
  background-color: rgb(217 45 32 / 0.2);
}
.tw-bg-default {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default-200 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default-300\\/50 {
  background-color: hsl(var(--coreui-default-300) / 0.5);
}
.tw-bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-50) / var(--coreui-default-50-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default-500 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-500) / var(--coreui-default-500-opacity, var(--tw-bg-opacity)));
}
.tw-bg-default\\/40 {
  background-color: hsl(var(--coreui-default) / 0.4);
}
.tw-bg-destructive {
  background-color: hsl(var(--destructive));
}
.tw-bg-divider {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-divider) / var(--coreui-divider-opacity, var(--tw-bg-opacity)));
}
.tw-bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.tw-bg-foreground {
  background-color: hsl(var(--foreground));
}
.tw-bg-foreground\\/10 {
  background-color: hsl(var(--foreground) / 0.1);
}
.tw-bg-input {
  background-color: hsl(var(--input));
}
.tw-bg-muted {
  background-color: hsl(var(--muted));
}
.tw-bg-overlay\\/30 {
  background-color: hsl(var(--coreui-overlay) / 0.3);
}
.tw-bg-overlay\\/50 {
  background-color: hsl(var(--coreui-overlay) / 0.5);
}
.tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.tw-bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 243 / var(--tw-bg-opacity));
}
.tw-bg-primary\\/20 {
  background-color: rgb(0 67 139 / 0.2);
}
.tw-bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.tw-bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-50) / var(--coreui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.tw-bg-secondary\\/20 {
  background-color: rgb(255 165 0 / 0.2);
}
.tw-bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.tw-bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-success-50) / var(--coreui-success-50-opacity, var(--tw-bg-opacity)));
}
.tw-bg-success\\/20 {
  background-color: rgb(3 152 85 / 0.2);
}
.tw-bg-transparent {
  background-color: transparent;
}
.tw-bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.tw-bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-50) / var(--coreui-warning-50-opacity, var(--tw-bg-opacity)));
}
.tw-bg-warning\\/20 {
  background-color: rgb(220 104 3 / 0.2);
}
.tw-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tw-bg-stripe-gradient {
  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.1) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.1) 75%, transparent 75%, transparent);
}
.tw-bg-\\[length\\:1\\.25rem_1\\.25rem\\] {
  background-size: 1.25rem 1.25rem;
}
.tw-fill-current {
  fill: currentColor;
}
.tw-stroke-current {
  stroke: currentColor;
}
.tw-stroke-default-300\\/50 {
  stroke: hsl(var(--coreui-default-300) / 0.5);
}
.tw-object-cover {
  object-fit: cover;
}
.tw-p-0 {
  padding: 0px;
}
.tw-p-1 {
  padding: 0.25rem;
}
.tw-p-1\\.5 {
  padding: 0.375rem;
}
.tw-p-2 {
  padding: 0.5rem;
}
.tw-p-2\\.5 {
  padding: 0.625rem;
}
.tw-p-3 {
  padding: 0.75rem;
}
.tw-p-4 {
  padding: 1rem;
}
.\\!tw-px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.tw-px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.tw-px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.tw-px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.tw-px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.tw-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.tw-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.tw-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.tw-py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.tw-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw-py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.tw-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.tw-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw-py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.\\!tw-pb-0 {
  padding-bottom: 0px !important;
}
.tw-pb-0 {
  padding-bottom: 0px;
}
.tw-pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.tw-pb-1 {
  padding-bottom: 0.25rem;
}
.tw-pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.tw-pb-2 {
  padding-bottom: 0.5rem;
}
.tw-pb-4 {
  padding-bottom: 1rem;
}
.tw-pe-2 {
  padding-inline-end: 0.5rem;
}
.tw-pl-0 {
  padding-left: 0px;
}
.tw-pl-0\\.5 {
  padding-left: 0.125rem;
}
.tw-pl-1 {
  padding-left: 0.25rem;
}
.tw-pl-2 {
  padding-left: 0.5rem;
}
.tw-pl-5 {
  padding-left: 1.25rem;
}
.tw-pr-0 {
  padding-right: 0px;
}
.tw-pr-0\\.5 {
  padding-right: 0.125rem;
}
.tw-pr-1 {
  padding-right: 0.25rem;
}
.tw-pr-2 {
  padding-right: 0.5rem;
}
.tw-pr-6 {
  padding-right: 1.5rem;
}
.tw-pr-9 {
  padding-right: 2.25rem;
}
.tw-pt-0 {
  padding-top: 0px;
}
.tw-pt-2 {
  padding-top: 0.5rem;
}
.tw-pt-4 {
  padding-top: 1rem;
}
.tw-text-left {
  text-align: left;
}
.tw-text-center {
  text-align: center;
}
.tw-text-start {
  text-align: start;
}
.tw-align-middle {
  vertical-align: middle;
}
.tw-font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.tw-font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.tw-text-\\[0\\.55rem\\] {
  font-size: 0.55rem;
}
.tw-text-\\[0\\.5rem\\] {
  font-size: 0.5rem;
}
.tw-text-\\[0\\.6rem\\] {
  font-size: 0.6rem;
}
.tw-text-\\[0\\.85em\\] {
  font-size: 0.85em;
}
.tw-text-\\[11px\\] {
  font-size: 11px;
}
.tw-text-\\[14px\\] {
  font-size: 14px;
}
.tw-text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.tw-text-large {
  font-size: var(--coreui-font-size-large);
  line-height: var(--coreui-line-height-large);
}
.tw-text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-medium {
  font-size: var(--coreui-font-size-medium);
  line-height: var(--coreui-line-height-medium);
}
.tw-text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-small {
  font-size: var(--coreui-font-size-small);
  line-height: var(--coreui-line-height-small);
}
.tw-text-tiny {
  font-size: var(--coreui-font-size-tiny);
  line-height: var(--coreui-line-height-tiny);
}
.tw-text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.tw-font-medium {
  font-weight: 500;
}
.tw-font-normal {
  font-weight: 400;
}
.tw-font-semibold {
  font-weight: 600;
}
.tw-uppercase {
  text-transform: uppercase;
}
.tw-tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tw-leading-6 {
  line-height: 1.5rem;
}
.tw-leading-\\[32px\\] {
  line-height: 32px;
}
.tw-leading-relaxed {
  line-height: 1.625;
}
.tw-leading-snug {
  line-height: 1.375;
}
.tw-tracking-wider {
  letter-spacing: 0.05em;
}
.\\!tw-text-danger {
  --tw-text-opacity: 1 !important;
  color: rgb(217 45 32 / var(--tw-text-opacity)) !important;
}
.tw-text-accent {
  color: hsl(var(--accent));
}
.tw-text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.tw-text-background {
  color: hsl(var(--background));
}
.tw-text-black {
  color: #121417 !important;
}
.tw-text-card-foreground {
  color: hsl(var(--card-foreground));
}
.tw-text-copilot-primary {
  color: hsl(var(--primary));
}
.tw-text-copilot-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.tw-text-current {
  color: currentColor;
}
.tw-text-danger {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.tw-text-danger-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-300) / var(--coreui-danger-300-opacity, var(--tw-text-opacity)));
}
.tw-text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-danger\\/80 {
  color: rgb(217 45 32 / 0.8);
}
.tw-text-default-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-text-opacity)));
}
.tw-text-default-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-500) / var(--coreui-default-500-opacity, var(--tw-text-opacity)));
}
.tw-text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-600) / var(--coreui-default-600-opacity, var(--tw-text-opacity)));
}
.tw-text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-destructive {
  color: hsl(var(--destructive));
}
.tw-text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.tw-text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.tw-text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.tw-text-foreground {
  color: hsl(var(--foreground));
}
.tw-text-foreground-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-400) / var(--coreui-foreground-400-opacity, var(--tw-text-opacity)));
}
.tw-text-foreground-500 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-500) / var(--coreui-foreground-500-opacity, var(--tw-text-opacity)));
}
.tw-text-foreground-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-600) / var(--coreui-foreground-600-opacity, var(--tw-text-opacity)));
}
.tw-text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.tw-text-inherit {
  color: inherit;
}
.tw-text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.tw-text-primary {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.tw-text-primary-300 {
  --tw-text-opacity: 1;
  color: rgb(122 157 195 / var(--tw-text-opacity));
}
.tw-text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-primary\\/80 {
  color: rgb(0 67 139 / 0.8);
}
.tw-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.tw-text-secondary-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-300) / var(--coreui-secondary-300-opacity, var(--tw-text-opacity)));
}
.tw-text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-secondary\\/80 {
  color: rgb(255 165 0 / 0.8);
}
.tw-text-success {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.tw-text-success-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-400) / var(--coreui-success-400-opacity, var(--tw-text-opacity)));
}
.tw-text-success-600 {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.tw-text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-success\\/80 {
  color: rgb(3 152 85 / 0.8);
}
.tw-text-warning {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity));
}
.tw-text-warning-400 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-400) / var(--coreui-warning-400-opacity, var(--tw-text-opacity)));
}
.tw-text-warning-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.tw-text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.tw-text-warning\\/80 {
  color: rgb(220 104 3 / 0.8);
}
.tw-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-underline {
  text-decoration-line: underline;
}
.tw-no-underline {
  text-decoration-line: none;
}
.tw-underline-offset-2 {
  text-underline-offset: 2px;
}
.tw-underline-offset-4 {
  text-underline-offset: 4px;
}
.tw-subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.tw-opacity-0 {
  opacity: 0;
}
.tw-opacity-100 {
  opacity: 1;
}
.tw-opacity-30 {
  opacity: 0.3;
}
.tw-opacity-50 {
  opacity: 0.5;
}
.tw-opacity-70 {
  opacity: 0.7;
}
.tw-opacity-75 {
  opacity: 0.75;
}
.tw-opacity-disabled {
  opacity: var(--coreui-disabled-opacity);
}
.tw-shadow-\\[0_1px_0px_0_rgba\\(0\\,0\\,0\\,0\\.05\\)\\] {
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-\\[0px_20px_20px_0px_rgb\\(0_0_0\\/0\\.05\\)\\] {
  --tw-shadow: 0px 20px 20px 0px rgb(0 0 0/0.05);
  --tw-shadow-colored: 0px 20px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-large {
  --tw-shadow: var(--coreui-box-shadow-large);
  --tw-shadow-colored: var(--coreui-box-shadow-large);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-medium {
  --tw-shadow: var(--coreui-box-shadow-medium);
  --tw-shadow-colored: var(--coreui-box-shadow-medium);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-small {
  --tw-shadow: var(--coreui-box-shadow-small);
  --tw-shadow-colored: var(--coreui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-danger\\/40 {
  --tw-shadow-color: rgb(217 45 32 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-default\\/50 {
  --tw-shadow-color: hsl(var(--coreui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-foreground\\/40 {
  --tw-shadow-color: hsl(var(--foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-primary\\/40 {
  --tw-shadow-color: rgb(0 67 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-secondary\\/40 {
  --tw-shadow-color: rgb(255 165 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-success\\/40 {
  --tw-shadow-color: rgb(3 152 85 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-shadow-warning\\/40 {
  --tw-shadow-color: rgb(220 104 3 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!tw-outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.tw-outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw-ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.tw-ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.tw-ring-background {
  --tw-ring-color: hsl(var(--background));
}
.tw-ring-danger {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 45 32 / var(--tw-ring-opacity));
}
.tw-ring-default {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-ring-opacity)));
}
.tw-ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--coreui-focus) / var(--coreui-focus-opacity, var(--tw-ring-opacity)));
}
.tw-ring-primary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 67 139 / var(--tw-ring-opacity));
}
.tw-ring-secondary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 165 0 / var(--tw-ring-opacity));
}
.tw-ring-success {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 152 85 / var(--tw-ring-opacity));
}
.tw-ring-transparent {
  --tw-ring-color: transparent;
}
.tw-ring-warning {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 104 3 / var(--tw-ring-opacity));
}
.tw-ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.tw-ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.tw-blur-lg {
  --tw-blur: blur(16px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.tw-saturate-150 {
  --tw-saturate: saturate(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.tw-filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.tw-backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-opacity-disabled {
  --tw-backdrop-opacity: opacity(var(--coreui-disabled-opacity));
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw-backdrop-saturate-150 {
  --tw-backdrop-saturate: saturate(1.5);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!tw-transition-none {
  transition-property: none !important;
}
.tw-transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-\\[color\\,opacity\\] {
  transition-property: color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-\\[transform\\,background-color\\,color\\] {
  transition-property: transform,background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-\\[transform\\,color\\,left\\,opacity\\] {
  transition-property: transform,color,left,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-none {
  transition-property: none;
}
.tw-transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.tw-transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.\\!tw-duration-100 {
  transition-duration: 100ms !important;
}
.\\!tw-duration-150 {
  transition-duration: 150ms !important;
}
.\\!tw-duration-200 {
  transition-duration: 200ms !important;
}
.\\!tw-duration-250 {
  transition-duration: 250ms !important;
}
.\\!tw-duration-300 {
  transition-duration: 300ms !important;
}
.\\!tw-duration-500 {
  transition-duration: 500ms !important;
}
.tw-duration-150 {
  transition-duration: 150ms;
}
.\\!tw-ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
.\\!tw-ease-soft-spring {
  transition-timing-function: cubic-bezier(0.155, 1.105, 0.295, 1.12) !important;
}
:root,.tw-light,[data-theme="light"] {
  color-scheme: light;
  --coreui-background: 0 0% 100%;
  --coreui-foreground-50: 0 0% 98.04%;
  --coreui-foreground-100: 240 4.76% 95.88%;
  --coreui-foreground-200: 240 5.88% 90%;
  --coreui-foreground-300: 240 4.88% 83.92%;
  --coreui-foreground-400: 240 5.03% 64.9%;
  --coreui-foreground-500: 240 3.83% 46.08%;
  --coreui-foreground-600: 240 5.2% 33.92%;
  --coreui-foreground-700: 240 5.26% 26.08%;
  --coreui-foreground-800: 240 3.7% 15.88%;
  --coreui-foreground-900: 240 5.88% 10%;
  --coreui-foreground: 201.81999999999994 24.44% 8.82%;
  --coreui-divider: 0 0% 6.67%;
  --coreui-divider-opacity: 0.15;
  --coreui-focus: 212.01999999999998 100% 46.67%;
  --coreui-overlay: 0 0% 0%;
  --coreui-content1: 0 0% 100%;
  --coreui-content1-foreground: 201.81999999999994 24.44% 8.82%;
  --coreui-content2: 240 4.76% 95.88%;
  --coreui-content2-foreground: 240 3.7% 15.88%;
  --coreui-content3: 240 5.88% 90%;
  --coreui-content3-foreground: 240 5.26% 26.08%;
  --coreui-content4: 240 4.88% 83.92%;
  --coreui-content4-foreground: 240 5.2% 33.92%;
  --coreui-default-50: 0 0% 98.04%;
  --coreui-default-100: 240 4.76% 95.88%;
  --coreui-default-200: 240 5.88% 90%;
  --coreui-default-300: 240 4.88% 83.92%;
  --coreui-default-400: 240 5.03% 64.9%;
  --coreui-default-500: 240 3.83% 46.08%;
  --coreui-default-600: 240 5.2% 33.92%;
  --coreui-default-700: 240 5.26% 26.08%;
  --coreui-default-800: 240 3.7% 15.88%;
  --coreui-default-900: 240 5.88% 10%;
  --coreui-default-foreground: 0 0% 0%;
  --coreui-default: 240 4.88% 83.92%;
  --coreui-primary-50: 212.5 92.31% 94.9%;
  --coreui-primary-100: 211.84000000000003 92.45% 89.61%;
  --coreui-primary-200: 211.84000000000003 92.45% 79.22%;
  --coreui-primary-300: 212.24 92.45% 68.82%;
  --coreui-primary-400: 212.14 92.45% 58.43%;
  --coreui-primary-500: 212.01999999999998 100% 46.67%;
  --coreui-primary-600: 212.14 100% 38.43%;
  --coreui-primary-700: 212.24 100% 28.82%;
  --coreui-primary-800: 211.84000000000003 100% 19.22%;
  --coreui-primary-900: 211.84000000000003 100% 9.61%;
  --coreui-primary-foreground: 0 0% 100%;
  --coreui-primary: 212.01999999999998 100% 46.67%;
  --coreui-secondary-50: 270 61.54% 94.9%;
  --coreui-secondary-100: 270 59.26% 89.41%;
  --coreui-secondary-200: 270 59.26% 78.82%;
  --coreui-secondary-300: 270 59.26% 68.24%;
  --coreui-secondary-400: 270 59.26% 57.65%;
  --coreui-secondary-500: 270 66.67% 47.06%;
  --coreui-secondary-600: 270 66.67% 37.65%;
  --coreui-secondary-700: 270 66.67% 28.24%;
  --coreui-secondary-800: 270 66.67% 18.82%;
  --coreui-secondary-900: 270 66.67% 9.41%;
  --coreui-secondary-foreground: 0 0% 100%;
  --coreui-secondary: 270 66.67% 47.06%;
  --coreui-success-50: 146.66999999999996 64.29% 94.51%;
  --coreui-success-100: 145.71000000000004 61.4% 88.82%;
  --coreui-success-200: 146.2 61.74% 77.45%;
  --coreui-success-300: 145.78999999999996 62.57% 66.47%;
  --coreui-success-400: 146.01 62.45% 55.1%;
  --coreui-success-500: 145.96000000000004 79.46% 43.92%;
  --coreui-success-600: 146.01 79.89% 35.1%;
  --coreui-success-700: 145.78999999999996 79.26% 26.47%;
  --coreui-success-800: 146.2 79.78% 17.45%;
  --coreui-success-900: 145.71000000000004 77.78% 8.82%;
  --coreui-success-foreground: 0 0% 0%;
  --coreui-success: 145.96000000000004 79.46% 43.92%;
  --coreui-warning-50: 54.55000000000001 91.67% 95.29%;
  --coreui-warning-100: 37.139999999999986 91.3% 90.98%;
  --coreui-warning-200: 37.139999999999986 91.3% 81.96%;
  --coreui-warning-300: 36.95999999999998 91.24% 73.14%;
  --coreui-warning-400: 37.00999999999999 91.26% 64.12%;
  --coreui-warning-500: 37.02999999999997 91.27% 55.1%;
  --coreui-warning-600: 37.00999999999999 74.22% 44.12%;
  --coreui-warning-700: 36.95999999999998 73.96% 33.14%;
  --coreui-warning-800: 37.139999999999986 75% 21.96%;
  --coreui-warning-900: 37.139999999999986 75% 10.98%;
  --coreui-warning-foreground: 0 0% 0%;
  --coreui-warning: 37.02999999999997 91.27% 55.1%;
  --coreui-danger-50: 339.13 92% 95.1%;
  --coreui-danger-100: 340 91.84% 90.39%;
  --coreui-danger-200: 339.3299999999999 90% 80.39%;
  --coreui-danger-300: 339.11 90.6% 70.78%;
  --coreui-danger-400: 339 90% 60.78%;
  --coreui-danger-500: 339.20000000000005 90.36% 51.18%;
  --coreui-danger-600: 339 86.54% 40.78%;
  --coreui-danger-700: 339.11 85.99% 30.78%;
  --coreui-danger-800: 339.3299999999999 86.54% 20.39%;
  --coreui-danger-900: 340 84.91% 10.39%;
  --coreui-danger-foreground: 0 0% 100%;
  --coreui-danger: 339.20000000000005 90.36% 51.18%;
  --coreui-divider-weight: 1px;
  --coreui-disabled-opacity: .5;
  --coreui-font-size-tiny: 0.75rem;
  --coreui-font-size-small: 0.875rem;
  --coreui-font-size-medium: 1rem;
  --coreui-font-size-large: 1.125rem;
  --coreui-line-height-tiny: 1rem;
  --coreui-line-height-small: 1.25rem;
  --coreui-line-height-medium: 1.5rem;
  --coreui-line-height-large: 1.75rem;
  --coreui-radius-small: 8px;
  --coreui-radius-medium: 12px;
  --coreui-radius-large: 14px;
  --coreui-border-width-small: 1px;
  --coreui-border-width-medium: 2px;
  --coreui-border-width-large: 3px;
  --coreui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.02), 0px 2px 10px 0px rgb(0 0 0 / 0.06), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --coreui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.03), 0px 2px 30px 0px rgb(0 0 0 / 0.08), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --coreui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.04), 0px 30px 60px 0px rgb(0 0 0 / 0.12), 0px 0px 1px 0px rgb(0 0 0 / 0.3);
  --coreui-hover-opacity: .8;
}
.tw-dark,[data-theme="dark"] {
  color-scheme: dark;
  --coreui-background: 0 0% 0%;
  --coreui-foreground-50: 240 5.88% 10%;
  --coreui-foreground-100: 240 3.7% 15.88%;
  --coreui-foreground-200: 240 5.26% 26.08%;
  --coreui-foreground-300: 240 5.2% 33.92%;
  --coreui-foreground-400: 240 3.83% 46.08%;
  --coreui-foreground-500: 240 5.03% 64.9%;
  --coreui-foreground-600: 240 4.88% 83.92%;
  --coreui-foreground-700: 240 5.88% 90%;
  --coreui-foreground-800: 240 4.76% 95.88%;
  --coreui-foreground-900: 0 0% 98.04%;
  --coreui-foreground: 210 5.56% 92.94%;
  --coreui-focus: 212.01999999999998 100% 46.67%;
  --coreui-overlay: 0 0% 0%;
  --coreui-divider: 0 0% 100%;
  --coreui-divider-opacity: 0.15;
  --coreui-content1: 240 5.88% 10%;
  --coreui-content1-foreground: 0 0% 98.04%;
  --coreui-content2: 240 3.7% 15.88%;
  --coreui-content2-foreground: 240 4.76% 95.88%;
  --coreui-content3: 240 5.26% 26.08%;
  --coreui-content3-foreground: 240 5.88% 90%;
  --coreui-content4: 240 5.2% 33.92%;
  --coreui-content4-foreground: 240 4.88% 83.92%;
  --coreui-default-50: 240 5.88% 10%;
  --coreui-default-100: 240 3.7% 15.88%;
  --coreui-default-200: 240 5.26% 26.08%;
  --coreui-default-300: 240 5.2% 33.92%;
  --coreui-default-400: 240 3.83% 46.08%;
  --coreui-default-500: 240 5.03% 64.9%;
  --coreui-default-600: 240 4.88% 83.92%;
  --coreui-default-700: 240 5.88% 90%;
  --coreui-default-800: 240 4.76% 95.88%;
  --coreui-default-900: 0 0% 98.04%;
  --coreui-default-foreground: 0 0% 100%;
  --coreui-default: 240 5.26% 26.08%;
  --coreui-primary-50: 211.84000000000003 100% 9.61%;
  --coreui-primary-100: 211.84000000000003 100% 19.22%;
  --coreui-primary-200: 212.24 100% 28.82%;
  --coreui-primary-300: 212.14 100% 38.43%;
  --coreui-primary-400: 212.01999999999998 100% 46.67%;
  --coreui-primary-500: 212.14 92.45% 58.43%;
  --coreui-primary-600: 212.24 92.45% 68.82%;
  --coreui-primary-700: 211.84000000000003 92.45% 79.22%;
  --coreui-primary-800: 211.84000000000003 92.45% 89.61%;
  --coreui-primary-900: 212.5 92.31% 94.9%;
  --coreui-primary-foreground: 0 0% 100%;
  --coreui-primary: 212.01999999999998 100% 46.67%;
  --coreui-secondary-50: 270 66.67% 9.41%;
  --coreui-secondary-100: 270 66.67% 18.82%;
  --coreui-secondary-200: 270 66.67% 28.24%;
  --coreui-secondary-300: 270 66.67% 37.65%;
  --coreui-secondary-400: 270 66.67% 47.06%;
  --coreui-secondary-500: 270 59.26% 57.65%;
  --coreui-secondary-600: 270 59.26% 68.24%;
  --coreui-secondary-700: 270 59.26% 78.82%;
  --coreui-secondary-800: 270 59.26% 89.41%;
  --coreui-secondary-900: 270 61.54% 94.9%;
  --coreui-secondary-foreground: 0 0% 100%;
  --coreui-secondary: 270 59.26% 57.65%;
  --coreui-success-50: 145.71000000000004 77.78% 8.82%;
  --coreui-success-100: 146.2 79.78% 17.45%;
  --coreui-success-200: 145.78999999999996 79.26% 26.47%;
  --coreui-success-300: 146.01 79.89% 35.1%;
  --coreui-success-400: 145.96000000000004 79.46% 43.92%;
  --coreui-success-500: 146.01 62.45% 55.1%;
  --coreui-success-600: 145.78999999999996 62.57% 66.47%;
  --coreui-success-700: 146.2 61.74% 77.45%;
  --coreui-success-800: 145.71000000000004 61.4% 88.82%;
  --coreui-success-900: 146.66999999999996 64.29% 94.51%;
  --coreui-success-foreground: 0 0% 0%;
  --coreui-success: 145.96000000000004 79.46% 43.92%;
  --coreui-warning-50: 37.139999999999986 75% 10.98%;
  --coreui-warning-100: 37.139999999999986 75% 21.96%;
  --coreui-warning-200: 36.95999999999998 73.96% 33.14%;
  --coreui-warning-300: 37.00999999999999 74.22% 44.12%;
  --coreui-warning-400: 37.02999999999997 91.27% 55.1%;
  --coreui-warning-500: 37.00999999999999 91.26% 64.12%;
  --coreui-warning-600: 36.95999999999998 91.24% 73.14%;
  --coreui-warning-700: 37.139999999999986 91.3% 81.96%;
  --coreui-warning-800: 37.139999999999986 91.3% 90.98%;
  --coreui-warning-900: 54.55000000000001 91.67% 95.29%;
  --coreui-warning-foreground: 0 0% 0%;
  --coreui-warning: 37.02999999999997 91.27% 55.1%;
  --coreui-danger-50: 340 84.91% 10.39%;
  --coreui-danger-100: 339.3299999999999 86.54% 20.39%;
  --coreui-danger-200: 339.11 85.99% 30.78%;
  --coreui-danger-300: 339 86.54% 40.78%;
  --coreui-danger-400: 339.20000000000005 90.36% 51.18%;
  --coreui-danger-500: 339 90% 60.78%;
  --coreui-danger-600: 339.11 90.6% 70.78%;
  --coreui-danger-700: 339.3299999999999 90% 80.39%;
  --coreui-danger-800: 340 91.84% 90.39%;
  --coreui-danger-900: 339.13 92% 95.1%;
  --coreui-danger-foreground: 0 0% 100%;
  --coreui-danger: 339.20000000000005 90.36% 51.18%;
  --coreui-divider-weight: 1px;
  --coreui-disabled-opacity: .5;
  --coreui-font-size-tiny: 0.75rem;
  --coreui-font-size-small: 0.875rem;
  --coreui-font-size-medium: 1rem;
  --coreui-font-size-large: 1.125rem;
  --coreui-line-height-tiny: 1rem;
  --coreui-line-height-small: 1.25rem;
  --coreui-line-height-medium: 1.5rem;
  --coreui-line-height-large: 1.75rem;
  --coreui-radius-small: 8px;
  --coreui-radius-medium: 12px;
  --coreui-radius-large: 14px;
  --coreui-border-width-small: 1px;
  --coreui-border-width-medium: 2px;
  --coreui-border-width-large: 3px;
  --coreui-box-shadow-small: 0px 0px 5px 0px rgb(0 0 0 / 0.05), 0px 2px 10px 0px rgb(0 0 0 / 0.2), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --coreui-box-shadow-medium: 0px 0px 15px 0px rgb(0 0 0 / 0.06), 0px 2px 30px 0px rgb(0 0 0 / 0.22), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --coreui-box-shadow-large: 0px 0px 30px 0px rgb(0 0 0 / 0.07), 0px 30px 60px 0px rgb(0 0 0 / 0.26), inset 0px 0px 1px 0px rgb(255 255 255 / 0.15);
  --coreui-hover-opacity: .9;
}
.tw-tap-highlight-transparent {
  -webkit-tap-highlight-color: transparent;
}
.tw-transition-background {
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-colors-opacity {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-height {
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-transform-opacity {
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-transform-background {
  transition-property: transform, background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-transform-colors {
   transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-transition-transform-colors-opacity {
   transition-property: transform, color, background, background-color, border-color, text-decoration-color, fill, stroke, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.tw-scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.tw-scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.\\[--picker-height\\:224px\\] {
  --picker-height: 224px;
}
.\\[--scale-enter\\:100\\%\\] {
  --scale-enter: 100%;
}
.\\[--scale-exit\\:100\\%\\] {
  --scale-exit: 100%;
}
.\\[--scroll-shadow-size\\:100px\\] {
  --scroll-shadow-size: 100px;
}
.\\[--slide-enter\\:0px\\] {
  --slide-enter: 0px;
}
.\\[--slide-exit\\:80px\\] {
  --slide-exit: 80px;
}
.\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.placeholder\\:tw-text-danger::placeholder {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.placeholder\\:tw-text-foreground-500::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-500) / var(--coreui-foreground-500-opacity, var(--tw-text-opacity)));
}
.placeholder\\:tw-text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:tw-text-primary::placeholder {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.placeholder\\:tw-text-secondary::placeholder {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.placeholder\\:tw-text-success-600::placeholder {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.placeholder\\:tw-text-warning-600::placeholder {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.before\\:tw-absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:tw-inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}
.before\\:tw-z-0::before {
  content: var(--tw-content);
  z-index: 0;
}
.before\\:tw-z-\\[-1\\]::before {
  content: var(--tw-content);
  z-index: -1;
}
.before\\:tw-box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}
.before\\:tw-block::before {
  content: var(--tw-content);
  display: block;
}
.before\\:tw-hidden::before {
  content: var(--tw-content);
  display: none;
}
.before\\:tw-h-0::before {
  content: var(--tw-content);
  height: 0px;
}
.before\\:tw-h-0\\.5::before {
  content: var(--tw-content);
  height: 0.125rem;
}
.before\\:tw-h-11::before {
  content: var(--tw-content);
  height: 2.75rem;
}
.before\\:tw-h-2::before {
  content: var(--tw-content);
  height: 0.5rem;
}
.before\\:tw-h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}
.before\\:tw-h-px::before {
  content: var(--tw-content);
  height: 1px;
}
.before\\:tw-w-0::before {
  content: var(--tw-content);
  width: 0px;
}
.before\\:tw-w-11::before {
  content: var(--tw-content);
  width: 2.75rem;
}
.before\\:tw-w-2::before {
  content: var(--tw-content);
  width: 0.5rem;
}
.before\\:tw-w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}
.before\\:tw-w-6::before {
  content: var(--tw-content);
  width: 1.5rem;
}
.before\\:tw--translate-x-full::before {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:tw--translate-y-1::before {
  content: var(--tw-content);
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:tw-rotate-0::before {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:tw-rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-shimmer {

  100% {
    content: var(--tw-content);
    transform: translateX(100%);
  }
}
.before\\:tw-animate-\\[shimmer_2s_infinite\\]::before {
  content: var(--tw-content);
  animation: tw-shimmer 2s infinite;
}
.before\\:tw-animate-none::before {
  content: var(--tw-content);
  animation: none;
}
.before\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.5);
}
.before\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.6);
}
.before\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::before {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.7);
}
.before\\:tw-rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:tw-rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.before\\:tw-rounded-sm::before {
  content: var(--tw-content);
  border-radius: 0.125rem;
}
.before\\:tw-border-2::before {
  content: var(--tw-content);
  border-width: 2px;
}
.before\\:tw-border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:tw-border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}
.before\\:tw-border-content4\\/30::before {
  content: var(--tw-content);
  border-color: hsl(var(--coreui-content4) / 0.3);
}
.before\\:tw-border-danger::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.before\\:tw-border-default::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.before\\:tw-bg-content1::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content1) / var(--coreui-content1-opacity, var(--tw-bg-opacity)));
}
.before\\:tw-bg-current::before {
  content: var(--tw-content);
  background-color: currentColor;
}
.before\\:tw-bg-danger::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.before\\:tw-bg-danger\\/20::before {
  content: var(--tw-content);
  background-color: rgb(217 45 32 / 0.2);
}
.before\\:tw-bg-default\\/40::before {
  content: var(--tw-content);
  background-color: hsl(var(--coreui-default) / 0.4);
}
.before\\:tw-bg-foreground::before {
  content: var(--tw-content);
  background-color: hsl(var(--foreground));
}
.before\\:tw-bg-primary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.before\\:tw-bg-primary\\/20::before {
  content: var(--tw-content);
  background-color: rgb(0 67 139 / 0.2);
}
.before\\:tw-bg-secondary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.before\\:tw-bg-secondary\\/20::before {
  content: var(--tw-content);
  background-color: rgb(255 165 0 / 0.2);
}
.before\\:tw-bg-success::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.before\\:tw-bg-success\\/20::before {
  content: var(--tw-content);
  background-color: rgb(3 152 85 / 0.2);
}
.before\\:tw-bg-warning::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.before\\:tw-bg-warning\\/20::before {
  content: var(--tw-content);
  background-color: rgb(220 104 3 / 0.2);
}
.before\\:tw-bg-gradient-to-r::before {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.before\\:tw-from-transparent::before {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.before\\:tw-via-content4::before {
  content: var(--tw-content);
  --tw-gradient-to: hsl(var(--coreui-content4) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--coreui-content4) / var(--coreui-content4-opacity, 1)) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.before\\:tw-to-transparent::before {
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.before\\:tw-opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}
.before\\:tw-opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}
.before\\:tw-shadow-small::before {
  content: var(--tw-content);
  --tw-shadow: var(--coreui-box-shadow-small);
  --tw-shadow-colored: var(--coreui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:tw-transition-colors::before {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.before\\:tw-transition-none::before {
  content: var(--tw-content);
  transition-property: none;
}
.before\\:tw-transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.before\\:tw-transition-transform::before {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.before\\:\\!tw-duration-300::before {
  content: var(--tw-content);
  transition-duration: 300ms !important;
}
.before\\:tw-duration-150::before {
  content: var(--tw-content);
  transition-duration: 150ms;
}
.before\\:tw-content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}
.before\\:tw-transition-width::before {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:tw-absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:tw-inset-0::after {
  content: var(--tw-content);
  inset: 0px;
}
.after\\:tw--bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}
.after\\:tw--bottom-\\[2px\\]::after {
  content: var(--tw-content);
  bottom: -2px;
}
.after\\:tw-bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:tw-left-0::after {
  content: var(--tw-content);
  left: 0px;
}
.after\\:tw-left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:tw-right-0::after {
  content: var(--tw-content);
  right: 0px;
}
.after\\:tw-top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\\:tw--z-10::after {
  content: var(--tw-content);
  z-index: -10;
}
.after\\:tw-z-0::after {
  content: var(--tw-content);
  z-index: 0;
}
.after\\:tw-ml-0::after {
  content: var(--tw-content);
  margin-left: 0px;
}
.after\\:tw-ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.after\\:tw-block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:tw-h-0::after {
  content: var(--tw-content);
  height: 0px;
}
.after\\:tw-h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
.after\\:tw-h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:tw-h-\\[2px\\]::after {
  content: var(--tw-content);
  height: 2px;
}
.after\\:tw-h-divider::after {
  content: var(--tw-content);
  height: var(--coreui-divider-weight);
}
.after\\:tw-h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:tw-h-px::after {
  content: var(--tw-content);
  height: 1px;
}
.after\\:tw-w-0::after {
  content: var(--tw-content);
  width: 0px;
}
.after\\:tw-w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
.after\\:tw-w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:tw-w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}
.after\\:tw-w-\\[80\\%\\]::after {
  content: var(--tw-content);
  width: 80%;
}
.after\\:tw-w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:tw-origin-center::after {
  content: var(--tw-content);
  transform-origin: center;
}
.after\\:tw--translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:tw-translate-y-1::after {
  content: var(--tw-content);
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:tw-rotate-0::after {
  content: var(--tw-content);
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:tw-scale-50::after {
  content: var(--tw-content);
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.large\\)\\/2\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-large) / 2);
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.5\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.5);
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.6\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.6);
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\*0\\.7\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) * 0.7);
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.medium\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-medium) / 3);
}
.after\\:tw-rounded-\\[calc\\(theme\\(borderRadius\\.small\\)\\/3\\)\\]::after {
  content: var(--tw-content);
  border-radius: calc(var(--coreui-radius-small) / 3);
}
.after\\:tw-rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:tw-rounded-none::after {
  content: var(--tw-content);
  border-radius: 0px;
}
.after\\:tw-rounded-xl::after {
  content: var(--tw-content);
  border-radius: 0.75rem;
}
.after\\:tw-bg-background::after {
  content: var(--tw-content);
  background-color: hsl(var(--background));
}
.after\\:tw-bg-content1::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content1) / var(--coreui-content1-opacity, var(--tw-bg-opacity)));
}
.after\\:tw-bg-content3::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content3) / var(--coreui-content3-opacity, var(--tw-bg-opacity)));
}
.after\\:tw-bg-current::after {
  content: var(--tw-content);
  background-color: currentColor;
}
.after\\:tw-bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.after\\:tw-bg-default::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
}
.after\\:tw-bg-default-foreground::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-bg-opacity)));
}
.after\\:tw-bg-divider::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-divider) / var(--coreui-divider-opacity, var(--tw-bg-opacity)));
}
.after\\:tw-bg-primary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.after\\:tw-bg-secondary::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.after\\:tw-bg-success::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.after\\:tw-bg-warning::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.after\\:tw-text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.after\\:tw-text-danger-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-text-default-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-text-primary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-text-secondary-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-text-success-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-text-warning-foreground::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.after\\:tw-opacity-0::after {
  content: var(--tw-content);
  opacity: 0;
}
.after\\:tw-opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}
.after\\:tw-shadow-\\[0_1px_0px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]::after {
  content: var(--tw-content);
  --tw-shadow: 0 1px 0px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 1px 0px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:tw-shadow-small::after {
  content: var(--tw-content);
  --tw-shadow: var(--coreui-box-shadow-small);
  --tw-shadow-colored: var(--coreui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:tw-transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.after\\:tw-transition-none::after {
  content: var(--tw-content);
  transition-property: none;
}
.after\\:tw-transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.after\\:\\!tw-duration-200::after {
  content: var(--tw-content);
  transition-duration: 200ms !important;
}
.after\\:tw-duration-150::after {
  content: var(--tw-content);
  transition-duration: 150ms;
}
.after\\:\\!tw-ease-linear::after {
  content: var(--tw-content);
  transition-timing-function: linear !important;
}
.after\\:tw-content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:tw-content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}
.after\\:tw-transition-background::after {
  content: var(--tw-content);
  transition-property: background;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:tw-transition-width::after {
  content: var(--tw-content);
  transition-property: width;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:tw-transition-height::after {
  content: var(--tw-content);
  transition-property: height;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.after\\:tw-transition-transform-opacity::after {
  content: var(--tw-content);
  transition-property: transform, opacity;
  transition-timing-function: ease;
  transition-duration: 250ms;
}
.first\\:tw--ml-0:first-child {
  margin-left: -0px;
}
.first\\:tw--ml-0\\.5:first-child {
  margin-left: -0.125rem;
}
.first\\:tw-mt-0:first-child {
  margin-top: 0px;
}
.first\\:tw-mt-2:first-child {
  margin-top: 0.5rem;
}
.first\\:tw-rounded-l-lg:first-child {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.first\\:tw-rounded-s-full:first-child {
  border-start-start-radius: 9999px;
  border-end-start-radius: 9999px;
}
.first\\:tw-rounded-s-large:first-child {
  border-start-start-radius: var(--coreui-radius-large);
  border-end-start-radius: var(--coreui-radius-large);
}
.first\\:tw-rounded-s-medium:first-child {
  border-start-start-radius: var(--coreui-radius-medium);
  border-end-start-radius: var(--coreui-radius-medium);
}
.first\\:tw-rounded-s-none:first-child {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
}
.first\\:tw-rounded-s-small:first-child {
  border-start-start-radius: var(--coreui-radius-small);
  border-end-start-radius: var(--coreui-radius-small);
}
.first\\:before\\:tw-rounded-l-lg:first-child::before {
  content: var(--tw-content);
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.last\\:tw-mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:tw-rounded-e-full:last-child {
  border-start-end-radius: 9999px;
  border-end-end-radius: 9999px;
}
.last\\:tw-rounded-e-large:last-child {
  border-start-end-radius: var(--coreui-radius-large);
  border-end-end-radius: var(--coreui-radius-large);
}
.last\\:tw-rounded-e-medium:last-child {
  border-start-end-radius: var(--coreui-radius-medium);
  border-end-end-radius: var(--coreui-radius-medium);
}
.last\\:tw-rounded-e-none:last-child {
  border-start-end-radius: 0px;
  border-end-end-radius: 0px;
}
.last\\:tw-rounded-e-small:last-child {
  border-start-end-radius: var(--coreui-radius-small);
  border-end-end-radius: var(--coreui-radius-small);
}
.last\\:tw-rounded-r-lg:last-child {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.last\\:before\\:tw-rounded-r-lg:last-child::before {
  content: var(--tw-content);
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.first-of-type\\:tw-rounded-r-none:first-of-type {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.last-of-type\\:tw-rounded-l-none:last-of-type {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.focus-within\\:tw-border-danger:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.focus-within\\:tw-border-default-foreground:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-border-opacity)));
}
.focus-within\\:tw-border-primary:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.focus-within\\:tw-border-ring:focus-within {
  border-color: hsl(var(--ring));
}
.focus-within\\:tw-border-secondary:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.focus-within\\:tw-border-success:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.focus-within\\:tw-border-warning:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.focus-within\\:tw-bg-danger-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:tw-bg-primary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 243 / var(--tw-bg-opacity));
}
.focus-within\\:tw-bg-secondary-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-50) / var(--coreui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:tw-bg-success-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-success-50) / var(--coreui-success-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:tw-bg-warning-50:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-50) / var(--coreui-warning-50-opacity, var(--tw-bg-opacity)));
}
.focus-within\\:tw-ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:tw-ring-ring\\/40:focus-within {
  --tw-ring-color: hsl(var(--ring) / 0.4);
}
.focus-within\\:after\\:tw-w-full:focus-within::after {
  content: var(--tw-content);
  width: 100%;
}
.hover\\:tw--translate-x-0:hover {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:tw-scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:tw-border-default:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.hover\\:tw-border-default-300:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-border-opacity)));
}
.hover\\:tw-border-default-400:hover {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-border-opacity)));
}
.hover\\:\\!tw-bg-danger:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!tw-bg-default:hover {
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity))) !important;
}
.hover\\:\\!tw-bg-foreground:hover {
  background-color: hsl(var(--foreground)) !important;
}
.hover\\:\\!tw-bg-primary:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!tw-bg-secondary:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!tw-bg-success:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!tw-bg-warning:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity)) !important;
}
.hover\\:tw-bg-copilot-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:tw-bg-danger-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-100) / var(--coreui-danger-100-opacity, var(--tw-bg-opacity)));
}
.hover\\:tw-bg-default-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.hover\\:tw-bg-default-200:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.hover\\:tw-bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:tw-bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.hover\\:tw-bg-muted:hover {
  background-color: hsl(var(--muted));
}
.hover\\:tw-bg-primary-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 217 232 / var(--tw-bg-opacity));
}
.hover\\:tw-bg-secondary-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-100) / var(--coreui-secondary-100-opacity, var(--tw-bg-opacity)));
}
.hover\\:tw-bg-success-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity));
}
.hover\\:tw-bg-warning-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-100) / var(--coreui-warning-100-opacity, var(--tw-bg-opacity)));
}
.hover\\:\\!tw-text-danger-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity))) !important;
}
.hover\\:\\!tw-text-primary-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity))) !important;
}
.hover\\:\\!tw-text-success-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity))) !important;
}
.hover\\:\\!tw-text-warning-foreground:hover {
  --tw-text-opacity: 1 !important;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity))) !important;
}
.hover\\:tw-text-secondary-foreground:hover {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.hover\\:tw-underline:hover {
  text-decoration-line: underline;
}
.hover\\:\\!tw-opacity-100:hover {
  opacity: 1 !important;
}
.hover\\:tw-opacity-100:hover {
  opacity: 1;
}
.hover\\:tw-opacity-80:hover {
  opacity: 0.8;
}
.hover\\:after\\:tw-bg-danger\\/20:hover::after {
  content: var(--tw-content);
  background-color: rgb(217 45 32 / 0.2);
}
.hover\\:after\\:tw-bg-foreground\\/10:hover::after {
  content: var(--tw-content);
  background-color: hsl(var(--foreground) / 0.1);
}
.hover\\:after\\:tw-bg-primary\\/20:hover::after {
  content: var(--tw-content);
  background-color: rgb(0 67 139 / 0.2);
}
.hover\\:after\\:tw-bg-secondary\\/20:hover::after {
  content: var(--tw-content);
  background-color: rgb(255 165 0 / 0.2);
}
.hover\\:after\\:tw-bg-success\\/20:hover::after {
  content: var(--tw-content);
  background-color: rgb(3 152 85 / 0.2);
}
.hover\\:after\\:tw-bg-warning\\/20:hover::after {
  content: var(--tw-content);
  background-color: rgb(220 104 3 / 0.2);
}
.hover\\:after\\:tw-opacity-100:hover::after {
  content: var(--tw-content);
  opacity: 1;
}
.focus-within\\:hover\\:tw-border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.focus-within\\:hover\\:tw-border-default-foreground:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-border-opacity)));
}
.focus-within\\:hover\\:tw-border-primary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.focus-within\\:hover\\:tw-border-secondary:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.focus-within\\:hover\\:tw-border-success:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.focus-within\\:hover\\:tw-border-warning:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.focus-within\\:hover\\:tw-bg-default-100:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.focus\\:tw-bg-danger-400\\/50:focus {
  background-color: hsl(var(--coreui-danger-400) / 0.5);
}
.focus\\:tw-bg-default-400\\/50:focus {
  background-color: hsl(var(--coreui-default-400) / 0.5);
}
.focus\\:tw-bg-primary-400\\/50:focus {
  background-color: rgb(82 127 176 / 0.5);
}
.focus\\:tw-bg-secondary-400\\/50:focus {
  background-color: hsl(var(--coreui-secondary-400) / 0.5);
}
.focus\\:tw-bg-success-400\\/50:focus {
  background-color: hsl(var(--coreui-success-400) / 0.5);
}
.focus\\:tw-bg-warning-400\\/50:focus {
  background-color: hsl(var(--coreui-warning-400) / 0.5);
}
.focus\\:tw-underline:focus {
  text-decoration-line: underline;
}
.focus\\:tw-shadow-sm:focus {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:tw-z-10:focus-visible {
  z-index: 10;
}
.focus-visible\\:tw-outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:tw-outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:tw-outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:tw-outline-focus:focus-visible {
  outline-color: hsl(var(--coreui-focus) / var(--coreui-focus-opacity, 1));
}
.active\\:tw-bg-default-200:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.active\\:tw-bg-default-300:active {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-bg-opacity)));
}
.active\\:tw-underline:active {
  text-decoration-line: underline;
}
.active\\:\\!tw-opacity-70:active {
  opacity: 0.7 !important;
}
.active\\:tw-opacity-disabled:active {
  opacity: var(--coreui-disabled-opacity);
}
.disabled\\:tw-invisible:disabled {
  visibility: hidden;
}
.disabled\\:tw-cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:tw-opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:tw-opacity-60:disabled {
  opacity: 0.6;
}
.tw-group:hover .group-hover\\:tw-block {
  display: block;
}
.tw-group:hover .group-hover\\:tw-hidden {
  display: none;
}
.tw-group:hover .group-hover\\:tw-border-current {
  border-color: currentColor;
}
.tw-group:hover .group-hover\\:tw-text-current {
  color: currentColor;
}
.tw-group.is-splitted .group-\\[\\.is-splitted\\]\\:tw-rounded-medium {
  border-radius: var(--coreui-radius-medium);
}
.tw-group.is-splitted .group-\\[\\.is-splitted\\]\\:tw-bg-content1 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content1) / var(--coreui-content1-opacity, var(--tw-bg-opacity)));
}
.tw-group.is-splitted .group-\\[\\.is-splitted\\]\\:tw-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-group.is-splitted .group-\\[\\.is-splitted\\]\\:tw-shadow-medium {
  --tw-shadow: var(--coreui-box-shadow-medium);
  --tw-shadow-colored: var(--coreui-box-shadow-medium);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.aria-expanded\\:tw-scale-\\[0\\.97\\][aria-expanded="true"] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.aria-expanded\\:tw-opacity-70[aria-expanded="true"] {
  opacity: 0.7;
}
.data-\\[disabled\\=true\\]\\:tw-pointer-events-none[data-disabled=true] {
  pointer-events: none;
}
.data-\\[focus-visible\\=true\\]\\:tw-z-10[data-focus-visible=true] {
  z-index: 10;
}
.data-\\[focused\\=true\\]\\:tw-z-10[data-focused=true] {
  z-index: 10;
}
.data-\\[has-label\\=true\\]\\:tw-mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_10px\\)\\][data-has-label=true] {
  margin-top: calc(var(--coreui-font-size-small) + 10px);
}
.data-\\[has-label\\=true\\]\\:tw-mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_12px\\)\\][data-has-label=true] {
  margin-top: calc(var(--coreui-font-size-small) + 12px);
}
.data-\\[has-label\\=true\\]\\:tw-mt-\\[calc\\(theme\\(fontSize\\.small\\)_\\+_8px\\)\\][data-has-label=true] {
  margin-top: calc(var(--coreui-font-size-small) + 8px);
}
.data-\\[open\\=true\\]\\:tw-flex[data-open=true] {
  display: flex;
}
.data-\\[justify\\=end\\]\\:tw-flex-grow[data-justify=end] {
  flex-grow: 1;
}
.data-\\[justify\\=start\\]\\:tw-flex-grow[data-justify=start] {
  flex-grow: 1;
}
.data-\\[justify\\=end\\]\\:tw-basis-0[data-justify=end] {
  flex-basis: 0px;
}
.data-\\[justify\\=start\\]\\:tw-basis-0[data-justify=start] {
  flex-basis: 0px;
}
.data-\\[focus-visible\\=true\\]\\:tw--translate-x-3[data-focus-visible=true] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:tw--translate-x-3[data-hover=true] {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[hover\\=true\\]\\:tw-translate-x-0[data-hover=true] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[before\\=true\\]\\:tw-rotate-180[data-before=true] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[direction\\=ascending\\]\\:tw-rotate-180[data-direction=ascending] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:tw--rotate-90[data-open=true] {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[open\\=true\\]\\:tw-rotate-180[data-open=true] {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[invisible\\=true\\]\\:tw-scale-0[data-invisible=true] {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[pressed\\=true\\]\\:tw-scale-\\[0\\.97\\][data-pressed=true] {
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[disabled\\=true\\]\\:tw-cursor-default[data-disabled=true] {
  cursor: default;
}
.data-\\[disabled\\=true\\]\\:tw-cursor-not-allowed[data-disabled=true] {
  cursor: not-allowed;
}
.data-\\[dragging\\=true\\]\\:tw-cursor-grabbing[data-dragging=true] {
  cursor: grabbing;
}
.data-\\[readonly\\=true\\]\\:tw-cursor-default[data-readonly=true] {
  cursor: default;
}
.data-\\[sortable\\=true\\]\\:tw-cursor-pointer[data-sortable=true] {
  cursor: pointer;
}
.data-\\[unavailable\\=true\\]\\:tw-cursor-default[data-unavailable=true] {
  cursor: default;
}
.data-\\[visible\\=true\\]\\:tw-cursor-pointer[data-visible=true] {
  cursor: pointer;
}
.data-\\[orientation\\=horizontal\\]\\:tw-flex-row[data-orientation=horizontal] {
  flex-direction: row;
}
.data-\\[has-helper\\=true\\]\\:tw-items-start[data-has-helper=true] {
  align-items: flex-start;
}
.data-\\[justify\\=start\\]\\:tw-justify-start[data-justify=start] {
  justify-content: flex-start;
}
.data-\\[justify\\=end\\]\\:tw-justify-end[data-justify=end] {
  justify-content: flex-end;
}
.data-\\[justify\\=center\\]\\:tw-justify-center[data-justify=center] {
  justify-content: center;
}
.data-\\[has-multiple-rows\\=true\\]\\:tw-rounded-large[data-has-multiple-rows=true] {
  border-radius: var(--coreui-radius-large);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-rounded-full[data-range-selection=true][data-selection-end=true][data-selected=true] {
  border-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-rounded-full[data-range-selection=true][data-selection-start=true][data-selected=true] {
  border-radius: 9999px;
}
.data-\\[menu-open\\=true\\]\\:tw-border-none[data-menu-open=true] {
  border-style: none;
}
.data-\\[active\\=true\\]\\:tw-border-danger[data-active=true] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.data-\\[active\\=true\\]\\:tw-border-default-400[data-active=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[active\\=true\\]\\:tw-border-primary[data-active=true] {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.data-\\[active\\=true\\]\\:tw-border-secondary[data-active=true] {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.data-\\[active\\=true\\]\\:tw-border-success[data-active=true] {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.data-\\[active\\=true\\]\\:tw-border-warning[data-active=true] {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.data-\\[focus\\=true\\]\\:tw-border-danger[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.data-\\[focus\\=true\\]\\:tw-border-default-foreground[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-border-opacity)));
}
.data-\\[focus\\=true\\]\\:tw-border-primary[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.data-\\[focus\\=true\\]\\:tw-border-secondary[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.data-\\[focus\\=true\\]\\:tw-border-success[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.data-\\[focus\\=true\\]\\:tw-border-warning[data-focus=true] {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.data-\\[hover\\=true\\]\\:tw-border-danger[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.data-\\[hover\\=true\\]\\:tw-border-default[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-border-default-400[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-border-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-border-primary[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.data-\\[hover\\=true\\]\\:tw-border-secondary[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.data-\\[hover\\=true\\]\\:tw-border-success[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.data-\\[hover\\=true\\]\\:tw-border-warning[data-hover=true] {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.data-\\[open\\=true\\]\\:tw-border-danger[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.data-\\[open\\=true\\]\\:tw-border-default-foreground[data-open=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-border-opacity)));
}
.data-\\[open\\=true\\]\\:tw-border-primary[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.data-\\[open\\=true\\]\\:tw-border-secondary[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.data-\\[open\\=true\\]\\:tw-border-success[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.data-\\[open\\=true\\]\\:tw-border-warning[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.data-\\[active\\=true\\]\\:tw-bg-danger[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:tw-bg-default-400[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-bg-opacity)));
}
.data-\\[active\\=true\\]\\:tw-bg-primary[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:tw-bg-secondary[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:tw-bg-success[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[active\\=true\\]\\:tw-bg-warning[data-active=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-content2[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-content2) / var(--coreui-content2-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-danger[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-danger-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-100) / var(--coreui-danger-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-danger\\/20[data-hover=true] {
  background-color: rgb(217 45 32 / 0.2);
}
.data-\\[hover\\=true\\]\\:tw-bg-default[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-default-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-default-200[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-default\\/40[data-hover=true] {
  background-color: hsl(var(--coreui-default) / 0.4);
}
.data-\\[hover\\=true\\]\\:tw-bg-foreground-200[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-foreground-200) / var(--coreui-foreground-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-primary[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-primary-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 217 232 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-primary-50[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 243 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-primary\\/20[data-hover=true] {
  background-color: rgb(0 67 139 / 0.2);
}
.data-\\[hover\\=true\\]\\:tw-bg-secondary[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-secondary-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-100) / var(--coreui-secondary-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-secondary-50[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-50) / var(--coreui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-secondary\\/20[data-hover=true] {
  background-color: rgb(255 165 0 / 0.2);
}
.data-\\[hover\\=true\\]\\:tw-bg-success[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-success-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-success\\/20[data-hover=true] {
  background-color: rgb(3 152 85 / 0.2);
}
.data-\\[hover\\=true\\]\\:tw-bg-transparent[data-hover=true] {
  background-color: transparent;
}
.data-\\[hover\\=true\\]\\:tw-bg-warning[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[hover\\=true\\]\\:tw-bg-warning-100[data-hover=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-100) / var(--coreui-warning-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-bg-warning\\/20[data-hover=true] {
  background-color: rgb(220 104 3 / 0.2);
}
.data-\\[in-range\\=false\\]\\:tw-bg-default-200[data-in-range=false] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.data-\\[in-range\\=true\\]\\:tw-bg-background\\/50[data-in-range=true] {
  background-color: hsl(var(--background) / 0.5);
}
.data-\\[in-range\\=true\\]\\:tw-bg-danger[data-in-range=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[in-range\\=true\\]\\:tw-bg-foreground[data-in-range=true] {
  background-color: hsl(var(--foreground));
}
.data-\\[in-range\\=true\\]\\:tw-bg-primary[data-in-range=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[in-range\\=true\\]\\:tw-bg-secondary[data-in-range=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[in-range\\=true\\]\\:tw-bg-success[data-in-range=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[in-range\\=true\\]\\:tw-bg-warning[data-in-range=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[loaded\\=true\\]\\:\\!tw-bg-transparent[data-loaded=true] {
  background-color: transparent !important;
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-danger[data-hover=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-foreground[data-hover=true][data-selected=true] {
  background-color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-primary[data-hover=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-secondary[data-hover=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-success[data-hover=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-warning[data-hover=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:tw-bg-transparent[data-outside-month=true][data-range-selection=true][data-selected=true] {
  background-color: transparent;
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-danger[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  background-color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-primary[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-secondary[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-success[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-warning[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-danger[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  background-color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-primary[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-secondary[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-success[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-bg-warning[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:tw-bg-danger[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:tw-bg-default[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-bg-foreground[data-selected=true] {
  background-color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:tw-bg-primary[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:tw-bg-secondary[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:tw-bg-success[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:tw-bg-warning[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[has-end-content\\=true\\]\\:tw-pe-1\\.5[data-has-end-content=true] {
  padding-inline-end: 0.375rem;
}
.data-\\[has-helper\\=true\\]\\:tw-pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+8px\\)\\][data-has-helper=true] {
  padding-bottom: calc(var(--coreui-font-size-tiny) + 8px);
}
.data-\\[has-helper\\=true\\]\\:tw-pb-\\[calc\\(theme\\(fontSize\\.tiny\\)_\\+_8px\\)\\][data-has-helper=true] {
  padding-bottom: calc(var(--coreui-font-size-tiny) + 8px);
}
.data-\\[has-start-content\\=true\\]\\:tw-ps-1\\.5[data-has-start-content=true] {
  padding-inline-start: 0.375rem;
}
.data-\\[has-title\\=true\\]\\:tw-pt-1[data-has-title=true] {
  padding-top: 0.25rem;
}
.data-\\[active\\=true\\]\\:tw-font-semibold[data-active=true] {
  font-weight: 600;
}
.data-\\[active\\=true\\]\\:tw-text-danger-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:tw-text-default-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:tw-text-primary-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:tw-text-secondary-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:tw-text-success-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[active\\=true\\]\\:tw-text-warning-foreground[data-active=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[disabled\\=true\\]\\:tw-text-default-300[data-disabled=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-danger-300[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-300) / var(--coreui-danger-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-foreground-500[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-500) / var(--coreui-foreground-500-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-primary-300[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(122 157 195 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-secondary-300[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-300) / var(--coreui-secondary-300-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-success-400[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-400) / var(--coreui-success-400-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:data-\\[placeholder\\=true\\]\\:tw-text-warning-400[data-placeholder=true][data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-400) / var(--coreui-warning-400-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:tw-text-danger[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:tw-text-foreground[data-editable=true] {
  color: hsl(var(--foreground));
}
.data-\\[editable\\=true\\]\\:tw-text-primary[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:tw-text-secondary[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:tw-text-success-600[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:tw-text-warning-600[data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-danger[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-danger-500[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-danger-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-default-500[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-500) / var(--coreui-default-500-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-default-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-foreground-400[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-400) / var(--coreui-foreground-400-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-foreground-600[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-600) / var(--coreui-foreground-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-primary[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-primary-400[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(82 127 176 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-primary-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-secondary[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-secondary-400[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-400) / var(--coreui-secondary-400-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-secondary-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-success[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-success-600[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-success-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-warning[data-hover=true] {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity));
}
.data-\\[hover\\=true\\]\\:tw-text-warning-600[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[hover\\=true\\]\\:tw-text-warning-foreground[data-hover=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:tw-text-danger[data-editable=true][data-invalid=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[invalid\\=true\\]\\:tw-text-danger-300[data-invalid=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-300) / var(--coreui-danger-300-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-background[data-hover=true][data-selected=true] {
  color: hsl(var(--background));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-danger-foreground[data-hover=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-primary-foreground[data-hover=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-secondary-foreground[data-hover=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-success-foreground[data-hover=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-warning-foreground[data-hover=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:data-\\[outside-month\\=true\\]\\:tw-text-default-300[data-outside-month=true][data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-danger-500[data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-foreground[data-range-selection=true][data-selected=true] {
  color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-primary[data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-secondary[data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-600[data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-warning-500[data-range-selection=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-500) / var(--coreui-warning-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-background[data-range-selection=true][data-selection-end=true][data-selected=true] {
  color: hsl(var(--background));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-danger-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-primary-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-secondary-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-warning-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-background[data-range-selection=true][data-selection-start=true][data-selected=true] {
  color: hsl(var(--background));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-danger-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-primary-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-secondary-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-warning-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-background[data-selected=true] {
  color: hsl(var(--background));
}
.data-\\[selected\\=true\\]\\:tw-text-danger[data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:tw-text-danger-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-default-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-primary[data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:tw-text-primary-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-secondary[data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:tw-text-secondary-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-success-600[data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[selected\\=true\\]\\:tw-text-success-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-warning-600[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[selected\\=true\\]\\:tw-text-warning-foreground[data-selected=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[unavailable\\=true\\]\\:tw-text-default-300[data-unavailable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-300) / var(--coreui-default-300-opacity, var(--tw-text-opacity)));
}
.data-\\[unavailable\\=true\\]\\:tw-line-through[data-unavailable=true] {
  text-decoration-line: line-through;
}
.data-\\[disabled\\=true\\]\\:data-\\[outside-month\\=true\\]\\:tw-opacity-0[data-outside-month=true][data-disabled=true] {
  opacity: 0;
}
.data-\\[disabled\\=true\\]\\:tw-opacity-30[data-disabled=true] {
  opacity: 0.3;
}
.data-\\[hover-unselected\\=true\\]\\:tw-opacity-disabled[data-hover-unselected=true] {
  opacity: var(--coreui-disabled-opacity);
}
.data-\\[hover\\=true\\]\\:tw-opacity-hover[data-hover=true] {
  opacity: var(--coreui-hover-opacity);
}
.data-\\[in-range\\=true\\]\\:tw-opacity-100[data-in-range=true] {
  opacity: 1;
}
.data-\\[invisible\\=true\\]\\:tw-opacity-0[data-invisible=true] {
  opacity: 0;
}
.data-\\[loaded\\=true\\]\\:tw-opacity-100[data-loaded=true] {
  opacity: 1;
}
.data-\\[moving\\]\\:tw-opacity-100[data-moving] {
  opacity: 1;
}
.data-\\[pressed\\=true\\]\\:tw-opacity-50[data-pressed=true] {
  opacity: 0.5;
}
.data-\\[pressed\\=true\\]\\:tw-opacity-70[data-pressed=true] {
  opacity: 0.7;
}
.data-\\[visible\\=true\\]\\:tw-opacity-100[data-visible=true] {
  opacity: 1;
}
.data-\\[active\\=true\\]\\:tw-shadow-md[data-active=true] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[hover\\=true\\]\\:tw-shadow-lg[data-hover=true] {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:tw-shadow-md[data-selection-end=true][data-selected=true] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:tw-shadow-md[data-selection-start=true][data-selected=true] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:tw-shadow-md[data-selected=true] {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[selected\\=true\\]\\:tw-shadow-none[data-selected=true] {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[active\\=true\\]\\:tw-shadow-danger\\/40[data-active=true] {
  --tw-shadow-color: rgb(217 45 32 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:tw-shadow-default\\/50[data-active=true] {
  --tw-shadow-color: hsl(var(--coreui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:tw-shadow-primary\\/40[data-active=true] {
  --tw-shadow-color: rgb(0 67 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:tw-shadow-secondary\\/40[data-active=true] {
  --tw-shadow-color: rgb(255 165 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:tw-shadow-success\\/40[data-active=true] {
  --tw-shadow-color: rgb(3 152 85 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[active\\=true\\]\\:tw-shadow-warning\\/40[data-active=true] {
  --tw-shadow-color: rgb(220 104 3 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-danger\\/30[data-hover=true] {
  --tw-shadow-color: rgb(217 45 32 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-default\\/50[data-hover=true] {
  --tw-shadow-color: hsl(var(--coreui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-primary\\/30[data-hover=true] {
  --tw-shadow-color: rgb(0 67 139 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-secondary\\/30[data-hover=true] {
  --tw-shadow-color: rgb(255 165 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-success\\/30[data-hover=true] {
  --tw-shadow-color: rgb(3 152 85 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[hover\\=true\\]\\:tw-shadow-warning\\/30[data-hover=true] {
  --tw-shadow-color: rgb(220 104 3 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-danger\\/40[data-selected=true] {
  --tw-shadow-color: rgb(217 45 32 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-foreground\\/40[data-selected=true] {
  --tw-shadow-color: hsl(var(--foreground) / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-primary\\/40[data-selected=true] {
  --tw-shadow-color: rgb(0 67 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-secondary\\/40[data-selected=true] {
  --tw-shadow-color: rgb(255 165 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-success\\/40[data-selected=true] {
  --tw-shadow-color: rgb(3 152 85 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selected\\=true\\]\\:tw-shadow-warning\\/40[data-selected=true] {
  --tw-shadow-color: rgb(220 104 3 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[focus-visible\\=true\\]\\:tw-outline-2[data-focus-visible=true] {
  outline-width: 2px;
}
.data-\\[focus-visible\\=true\\]\\:tw-outline-offset-2[data-focus-visible=true] {
  outline-offset: 2px;
}
.data-\\[focus-visible\\=true\\]\\:tw-outline-focus[data-focus-visible=true] {
  outline-color: hsl(var(--coreui-focus) / var(--coreui-focus-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-danger-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-default-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-primary-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-secondary-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-success-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, 1));
}
.data-\\[focus-visible\\]\\:tw-outline-warning-foreground[data-focus-visible] {
  outline-color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, 1));
}
.data-\\[menu-open\\=true\\]\\:tw-backdrop-blur-xl[data-menu-open=true] {
  --tw-backdrop-blur: blur(24px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.data-\\[disabled\\=true\\]\\:tw-transition-none[data-disabled=true] {
  transition-property: none;
}
.data-\\[hover\\=true\\]\\:tw-transition-colors[data-hover=true] {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.data-\\[moving\\=true\\]\\:tw-transition-transform[data-moving=true] {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.data-\\[sortable\\=true\\]\\:tw-transition-colors[data-sortable=true] {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}
.data-\\[hide-scroll\\=true\\]\\:tw-scrollbar-hide[data-hide-scroll=true] {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.data-\\[hide-scroll\\=true\\]\\:tw-scrollbar-hide[data-hide-scroll=true]::-webkit-scrollbar {
  display: none;
}
.data-\\[top-bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(\\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-bottom-scroll=true] {
  mask-image: linear-gradient(#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[top-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(0deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-top-scroll=true] {
  mask-image: linear-gradient(0deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[bottom-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(180deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-bottom-scroll=true] {
  mask-image: linear-gradient(180deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(270deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-scroll=true] {
  mask-image: linear-gradient(270deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(90deg\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-right-scroll=true] {
  mask-image: linear-gradient(90deg,#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[left-right-scroll\\=true\\]\\:\\[mask-image\\:linear-gradient\\(to_right\\2c \\#000\\2c \\#000\\2c transparent_0\\2c \\#000_var\\(--scroll-shadow-size\\)\\2c \\#000_calc\\(100\\%_-_var\\(--scroll-shadow-size\\)\\)\\2c transparent\\)\\][data-left-right-scroll=true] {
  mask-image: linear-gradient(to right,#000,#000,transparent 0,#000 var(--scroll-shadow-size),#000 calc(100% - var(--scroll-shadow-size)),transparent);
}
.data-\\[placement\\=bottom-end\\]\\:before\\:tw--top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=bottom-end]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-end\\]\\:before\\:tw-right-3[data-placement=bottom-end]::before {
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=bottom-start\\]\\:before\\:tw--top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=bottom-start]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom-start\\]\\:before\\:tw-left-3[data-placement=bottom-start]::before {
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=bottom\\]\\:before\\:tw--top-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=bottom]::before {
  content: var(--tw-content);
  top: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=bottom\\]\\:before\\:tw-left-1\\/2[data-placement=bottom]::before {
  content: var(--tw-content);
  left: 50%;
}
.data-\\[placement\\=left-end\\]\\:before\\:tw--right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement=left-end]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-end\\]\\:before\\:tw-bottom-1\\/4[data-placement=left-end]::before {
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=left-start\\]\\:before\\:tw--right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement=left-start]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=left-start\\]\\:before\\:tw-top-1\\/4[data-placement=left-start]::before {
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=left\\]\\:before\\:tw--right-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement=left]::before {
  content: var(--tw-content);
  right: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=left\\]\\:before\\:tw-top-1\\/2[data-placement=left]::before {
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=right-end\\]\\:before\\:tw--left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement=right-end]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-end\\]\\:before\\:tw-bottom-1\\/4[data-placement=right-end]::before {
  content: var(--tw-content);
  bottom: 25%;
}
.data-\\[placement\\=right-start\\]\\:before\\:tw--left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_3px\\)\\][data-placement=right-start]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 3px) * -1);
}
.data-\\[placement\\=right-start\\]\\:before\\:tw-top-1\\/4[data-placement=right-start]::before {
  content: var(--tw-content);
  top: 25%;
}
.data-\\[placement\\=right\\]\\:before\\:tw--left-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_2px\\)\\][data-placement=right]::before {
  content: var(--tw-content);
  left: calc(calc(1.25rem / 4 - 2px) * -1);
}
.data-\\[placement\\=right\\]\\:before\\:tw-top-1\\/2[data-placement=right]::before {
  content: var(--tw-content);
  top: 50%;
}
.data-\\[placement\\=top-end\\]\\:before\\:tw--bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=top-end]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-end\\]\\:before\\:tw-right-3[data-placement=top-end]::before {
  content: var(--tw-content);
  right: 0.75rem;
}
.data-\\[placement\\=top-start\\]\\:before\\:tw--bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=top-start]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top-start\\]\\:before\\:tw-left-3[data-placement=top-start]::before {
  content: var(--tw-content);
  left: 0.75rem;
}
.data-\\[placement\\=top\\]\\:before\\:tw--bottom-\\[calc\\(theme\\(spacing\\.5\\)\\/4_-_1\\.5px\\)\\][data-placement=top]::before {
  content: var(--tw-content);
  bottom: calc(calc(1.25rem / 4 - 1.5px) * -1);
}
.data-\\[placement\\=top\\]\\:before\\:tw-left-1\\/2[data-placement=top]::before {
  content: var(--tw-content);
  left: 50%;
}
.data-\\[arrow\\=true\\]\\:before\\:tw-block[data-arrow=true]::before {
  content: var(--tw-content);
  display: block;
}
.data-\\[outside-month\\=true\\]\\:before\\:tw-hidden[data-outside-month=true]::before {
  content: var(--tw-content);
  display: none;
}
.data-\\[placement\\=bottom\\]\\:before\\:tw--translate-x-1\\/2[data-placement=bottom]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=left\\]\\:before\\:tw--translate-y-1\\/2[data-placement=left]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=right\\]\\:before\\:tw--translate-y-1\\/2[data-placement=right]::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[placement\\=top\\]\\:before\\:tw--translate-x-1\\/2[data-placement=top]::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[loaded\\=true\\]\\:before\\:tw-animate-none[data-loaded=true]::before {
  content: var(--tw-content);
  animation: none;
}
.data-\\[range-end\\=true\\]\\:before\\:tw-rounded-r-full[data-range-end=true]::before {
  content: var(--tw-content);
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.data-\\[range-start\\=true\\]\\:before\\:tw-rounded-l-full[data-range-start=true]::before {
  content: var(--tw-content);
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.data-\\[selection-end\\=true\\]\\:before\\:tw-rounded-r-full[data-selection-end=true]::before {
  content: var(--tw-content);
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.data-\\[selection-start\\=true\\]\\:before\\:tw-rounded-l-full[data-selection-start=true]::before {
  content: var(--tw-content);
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-danger-50[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-foreground\\/10[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  background-color: hsl(var(--foreground) / 0.1);
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-primary-50[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 243 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-secondary-50[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-50) / var(--coreui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-success-100[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 223 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-warning-100[data-range-selection=true][data-selected=true]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-100) / var(--coreui-warning-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[loaded\\=true\\]\\:before\\:tw-opacity-0[data-loaded=true]::before {
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:before\\:tw-opacity-100[data-selected=true]::before {
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[focus\\=true\\]\\:after\\:tw-w-full[data-focus=true]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[open\\=true\\]\\:after\\:tw-w-full[data-open=true]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[dragging\\=true\\]\\:after\\:tw-scale-100[data-dragging=true]::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[dragging\\=true\\]\\:after\\:tw-scale-80[data-dragging=true]::after {
  content: var(--tw-content);
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-danger[data-selected=true]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-foreground[data-selected=true]::after {
  content: var(--tw-content);
  background-color: hsl(var(--foreground));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-primary[data-selected=true]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-secondary[data-selected=true]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-success[data-selected=true]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selected\\=true\\]\\:after\\:tw-bg-warning[data-selected=true]::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[loaded\\=true\\]\\:after\\:tw-opacity-0[data-loaded=true]::after {
  content: var(--tw-content);
  opacity: 0;
}
.data-\\[selected\\=true\\]\\:after\\:tw-opacity-100[data-selected=true]::after {
  content: var(--tw-content);
  opacity: 1;
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-danger:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-default:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-border-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-primary:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-secondary:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-success:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-border-warning:focus[data-selectable=true] {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.data-\\[invalid\\=true\\]\\:focus\\:tw-bg-danger-400\\/50:focus[data-invalid=true] {
  background-color: hsl(var(--coreui-danger-400) / 0.5);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-danger:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-danger\\/20:focus[data-selectable=true] {
  background-color: rgb(217 45 32 / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-default:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-default-100:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-default\\/40:focus[data-selectable=true] {
  background-color: hsl(var(--coreui-default) / 0.4);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-primary:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-primary\\/20:focus[data-selectable=true] {
  background-color: rgb(0 67 139 / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-secondary:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-secondary\\/20:focus[data-selectable=true] {
  background-color: rgb(255 165 0 / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-success:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-success\\/20:focus[data-selectable=true] {
  background-color: rgb(3 152 85 / 0.2);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-warning:focus[data-selectable=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-bg-warning\\/20:focus[data-selectable=true] {
  background-color: rgb(220 104 3 / 0.2);
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-danger:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-default-foreground:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-primary:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-secondary:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-success:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-success-600:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-warning:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity));
}
.data-\\[editable\\=true\\]\\:focus\\:tw-text-warning-600:focus[data-editable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-600) / var(--coreui-warning-600-opacity, var(--tw-text-opacity)));
}
.data-\\[invalid\\=true\\]\\:data-\\[editable\\=true\\]\\:focus\\:tw-text-danger:focus[data-editable=true][data-invalid=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-danger:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-danger-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-default-500:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-500) / var(--coreui-default-500-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-default-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-primary:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-primary-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-secondary:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-secondary-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-success:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-success-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-warning:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-text-warning-foreground:focus[data-selectable=true] {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-danger\\/30:focus[data-selectable=true] {
  --tw-shadow-color: rgb(217 45 32 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-default\\/50:focus[data-selectable=true] {
  --tw-shadow-color: hsl(var(--coreui-default) / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-primary\\/30:focus[data-selectable=true] {
  --tw-shadow-color: rgb(0 67 139 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-secondary\\/30:focus[data-selectable=true] {
  --tw-shadow-color: rgb(255 165 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-success\\/30:focus[data-selectable=true] {
  --tw-shadow-color: rgb(3 152 85 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.data-\\[selectable\\=true\\]\\:focus\\:tw-shadow-warning\\/30:focus[data-selectable=true] {
  --tw-shadow-color: rgb(220 104 3 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw-pointer-events-auto {
  pointer-events: auto;
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw-pointer-events-auto {
  pointer-events: auto;
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw-left-0 {
  left: 0px;
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw-left-0 {
  left: 0px;
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-z-10 {
  z-index: 10;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-ml-4 {
  margin-left: 1rem;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-ml-5 {
  margin-left: 1.25rem;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-ml-6 {
  margin-left: 1.5rem;
}
.tw-group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:tw-ml-3 {
  margin-left: 0.75rem;
}
.tw-group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:tw-ml-4 {
  margin-left: 1rem;
}
.tw-group[data-selected][data-pressed] .group-data-\\[selected\\]\\:group-data-\\[pressed\\]\\:tw-ml-5 {
  margin-left: 1.25rem;
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-block {
  display: block;
}
.tw-group[data-has-helper=true] .group-data-\\[has-helper\\=true\\]\\:tw-flex {
  display: flex;
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-hidden {
  display: none;
}
.tw-group[data-pressed=true] .group-data-\\[pressed\\=true\\]\\:tw-w-5 {
  width: 1.25rem;
}
.tw-group[data-pressed=true] .group-data-\\[pressed\\=true\\]\\:tw-w-6 {
  width: 1.5rem;
}
.tw-group[data-pressed=true] .group-data-\\[pressed\\=true\\]\\:tw-w-7 {
  width: 1.75rem;
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 6px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 8px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 8px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_20px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-small) / 2 + 20px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.small\\)\\/2_\\+_24px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-small) / 2 + 24px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(100\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_\\+_16px\\)\\] {
  --tw-translate-y: calc(calc(100% + var(--coreui-font-size-tiny) / 2 + 16px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_3\\.5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 3.5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_4px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 4px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 6px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_6px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 6px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.small\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-small) / 2 - 8px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_5px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 5px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 8px) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw--translate-y-\\[calc\\(50\\%_\\+_theme\\(fontSize\\.tiny\\)\\/2_-_8px_-_theme\\(borderWidth\\.medium\\)\\)\\] {
  --tw-translate-y: calc(calc(50% + var(--coreui-font-size-tiny) / 2 - 8px - var(--coreui-border-width-medium)) * -1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-copied=true] .group-data-\\[copied\\=true\\]\\:tw-scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-copied=true] .group-data-\\[copied\\=true\\]\\:tw-scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw-scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw-scale-85 {
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-pressed=true] .group-data-\\[pressed\\=true\\]\\:tw-scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-disabled=true] .group-data-\\[disabled\\=true\\]\\:tw-cursor-not-allowed {
  cursor: not-allowed;
}
.tw-group[data-has-multiple-months=true] .group-data-\\[has-multiple-months\\=true\\]\\:tw-flex-row {
  flex-direction: row;
}
.tw-group[data-has-label=true] .group-data-\\[has-label\\=true\\]\\:tw-items-start {
  align-items: flex-start;
}
.tw-group[data-has-label=true] .group-data-\\[has-label\\=true\\]\\:tw-items-end {
  align-items: flex-end;
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-default-foreground {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-border-opacity)));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-success {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:tw-border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-default-500 {
  --tw-border-opacity: 1;
  border-color: hsl(var(--coreui-default-500) / var(--coreui-default-500-opacity, var(--tw-border-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(0 67 139 / var(--tw-border-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(255 165 0 / var(--tw-border-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-success {
  --tw-border-opacity: 1;
  border-color: rgb(3 152 85 / var(--tw-border-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 236 243 / var(--tw-bg-opacity));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-secondary-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-secondary-50) / var(--coreui-secondary-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-success-50) / var(--coreui-success-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:tw-bg-warning-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-warning-50) / var(--coreui-warning-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-hover-unselected=true] .group-data-\\[hover-unselected\\=true\\]\\:tw-bg-default-100 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:tw-bg-danger-50 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-default-400 {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-400) / var(--coreui-default-400-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 139 / var(--tw-bg-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(3 152 85 / var(--tw-bg-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity));
}
.tw-group[data-has-helper=true] .group-data-\\[has-helper\\=true\\]\\:tw-pt-2 {
  padding-top: 0.5rem;
}
.tw-group[data-has-helper=true] .group-data-\\[has-helper\\=true\\]\\:tw-pt-3 {
  padding-top: 0.75rem;
}
.tw-group[data-has-helper=true] .group-data-\\[has-helper\\=true\\]\\:tw-pt-4 {
  padding-top: 1rem;
}
.tw-group[data-has-label=true] .group-data-\\[has-label\\=true\\]\\:tw-pt-4 {
  padding-top: 1rem;
}
.tw-group[data-has-label=true] .group-data-\\[has-label\\=true\\]\\:tw-pt-5 {
  padding-top: 1.25rem;
}
.tw-group[data-disabled=true] .group-data-\\[disabled\\=true\\]\\:tw-text-foreground-300 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-foreground-300) / var(--coreui-foreground-300-opacity, var(--tw-text-opacity)));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw-text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-600) / var(--coreui-default-600-opacity, var(--tw-text-opacity)));
}
.tw-group[data-filled-within=true] .group-data-\\[filled-within\\=true\\]\\:tw-text-foreground {
  color: hsl(var(--foreground));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw-text-default-600 {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-600) / var(--coreui-default-600-opacity, var(--tw-text-opacity)));
}
.tw-group[data-filled=true] .group-data-\\[filled\\=true\\]\\:tw-text-foreground {
  color: hsl(var(--foreground));
}
.tw-group[data-has-value=true] .group-data-\\[has-value\\=true\\]\\:tw-text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-has-value=true] .group-data-\\[has-value\\=true\\]\\:tw-text-foreground {
  color: hsl(var(--foreground));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:tw-text-danger {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-danger {
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-danger-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-default-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-default-foreground) / var(--coreui-default-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-foreground {
  color: hsl(var(--foreground));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-primary {
  --tw-text-opacity: 1;
  color: rgb(0 67 139 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-primary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-primary-foreground) / var(--coreui-primary-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-secondary {
  --tw-text-opacity: 1;
  color: rgb(255 165 0 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-secondary-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-secondary-foreground) / var(--coreui-secondary-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-success {
  --tw-text-opacity: 1;
  color: rgb(3 152 85 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-success-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-warning {
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-text-warning-foreground {
  --tw-text-opacity: 1;
  color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
}
.tw-group[data-copied=true] .group-data-\\[copied\\=true\\]\\:tw-opacity-0 {
  opacity: 0;
}
.tw-group[data-copied=true] .group-data-\\[copied\\=true\\]\\:tw-opacity-100 {
  opacity: 1;
}
.tw-group[data-hover=true] .group-data-\\[hover\\=true\\]\\:tw-opacity-100 {
  opacity: 1;
}
.tw-group[data-loaded=true] .group-data-\\[loaded\\=true\\]\\:tw-opacity-100 {
  opacity: 1;
}
.tw-group[data-pressed=true] .group-data-\\[pressed\\=true\\]\\:tw-opacity-70 {
  opacity: 0.7;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-opacity-0 {
  opacity: 0;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-opacity-100 {
  opacity: 1;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:tw-opacity-60 {
  opacity: 0.6;
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-ring-focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: hsl(var(--coreui-focus) / var(--coreui-focus-opacity, var(--tw-ring-opacity)));
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.tw-group[data-focus-visible=true] .group-data-\\[focus-visible\\=true\\]\\:tw-ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.tw-group[data-odd=true] .group-data-\\[odd\\=true\\]\\:before\\:tw--z-10::before {
  content: var(--tw-content);
  z-index: -10;
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:before\\:tw-w-full::before {
  content: var(--tw-content);
  width: 100%;
}
.tw-group[data-open=true] .group-data-\\[open\\=true\\]\\:before\\:tw-translate-y-px::before {
  content: var(--tw-content);
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-open=true] .group-data-\\[open\\=true\\]\\:before\\:tw-rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-middle=true] .group-data-\\[middle\\=true\\]\\:before\\:tw-rounded-none::before {
  content: var(--tw-content);
  border-radius: 0px;
}
.tw-group[data-hover=true] .group-data-\\[hover\\=true\\]\\:before\\:tw-bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-odd=true] .group-data-\\[odd\\=true\\]\\:before\\:tw-bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-odd=true] .group-data-\\[odd\\=true\\]\\:before\\:tw-opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}
.tw-group[data-required=true] .group-data-\\[required\\=true\\]\\:after\\:tw-ml-0\\.5::after {
  content: var(--tw-content);
  margin-left: 0.125rem;
}
.tw-group[data-focus=true] .group-data-\\[focus\\=true\\]\\:after\\:tw-w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.tw-group[data-open=true] .group-data-\\[open\\=true\\]\\:after\\:tw-translate-y-0::after {
  content: var(--tw-content);
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-open=true] .group-data-\\[open\\=true\\]\\:after\\:tw--rotate-45::after {
  content: var(--tw-content);
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:after\\:tw-scale-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:after\\:tw-bg-danger::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity));
}
.tw-group[data-required=true] .group-data-\\[required\\=true\\]\\:after\\:tw-text-danger::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity));
}
.tw-group[data-selected=true] .group-data-\\[selected\\=true\\]\\:after\\:tw-opacity-100::after {
  content: var(--tw-content);
  opacity: 1;
}
.tw-group[data-required=true] .group-data-\\[required\\=true\\]\\:after\\:tw-content-\\[\\'\\*\\'\\]::after {
  --tw-content: '*';
  content: var(--tw-content);
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:first\\:before\\:tw-rounded-tl-lg:first-child::before {
  content: var(--tw-content);
  border-top-left-radius: 0.5rem;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:first\\:before\\:tw-rounded-bl-lg:first-child::before {
  content: var(--tw-content);
  border-bottom-left-radius: 0.5rem;
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:last\\:before\\:tw-rounded-tr-lg:last-child::before {
  content: var(--tw-content);
  border-top-right-radius: 0.5rem;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:last\\:before\\:tw-rounded-br-lg:last-child::before {
  content: var(--tw-content);
  border-bottom-right-radius: 0.5rem;
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:hover\\:tw-border-danger:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:hover\\:tw-bg-danger-100:hover {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-100) / var(--coreui-danger-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:tw-border-danger:hover:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity));
}
.tw-group[data-invalid=true] .group-data-\\[invalid\\=true\\]\\:focus-within\\:hover\\:tw-bg-danger-50:hover:focus-within {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
}
.tw-group[aria-selected=false][data-hover=true] .group-aria-\\[selected\\=false\\]\\:group-data-\\[hover\\=true\\]\\:before\\:tw-bg-default-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-100) / var(--coreui-default-100-opacity, var(--tw-bg-opacity)));
}
.tw-group[aria-selected=false][data-hover=true] .group-aria-\\[selected\\=false\\]\\:group-data-\\[hover\\=true\\]\\:before\\:tw-opacity-70::before {
  content: var(--tw-content);
  opacity: 0.7;
}
.tw-peer[data-filled=true] ~ .peer-data-\\[filled\\=true\\]\\:tw-block {
  display: block;
}
.tw-peer[data-filled=true] ~ .peer-data-\\[filled\\=true\\]\\:tw-opacity-70 {
  opacity: 0.7;
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:tw-transition-none {
    transition-property: none;
  }

  .motion-reduce\\:after\\:tw-transition-none::after {
    content: var(--tw-content);
    transition-property: none;
  }
}
@media (min-width: 640px) {

  .sm\\:tw-mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:tw-mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:tw-my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .sm\\:tw-my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:tw-items-start {
    align-items: flex-start;
  }

  .sm\\:tw-items-end {
    align-items: flex-end;
  }

  .sm\\:tw-items-center {
    align-items: center;
  }

  .sm\\:\\[--scale-enter\\:100\\%\\] {
    --scale-enter: 100%;
  }

  .sm\\:\\[--scale-exit\\:103\\%\\] {
    --scale-exit: 103%;
  }

  .sm\\:\\[--slide-enter\\:0px\\] {
    --slide-enter: 0px;
  }

  .sm\\:\\[--slide-exit\\:0px\\] {
    --slide-exit: 0px;
  }

  .sm\\:data-\\[visible\\=true\\]\\:tw-opacity-0[data-visible=true] {
    opacity: 0;
  }

  .tw-group[data-hover=true] .sm\\:group-data-\\[hover\\=true\\]\\:data-\\[visible\\=true\\]\\:tw-opacity-100[data-visible=true] {
    opacity: 1;
  }
}
.rtl\\:tw-left-1:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.25rem;
}
.rtl\\:tw-left-1\\.5:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.375rem;
}
.rtl\\:tw-left-3:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.75rem;
}
.rtl\\:tw-left-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  left: unset;
}
.rtl\\:tw-left-auto:where([dir="rtl"], [dir="rtl"] *) {
  left: auto;
}
.rtl\\:tw-right-0:where([dir="rtl"], [dir="rtl"] *) {
  right: 0px;
}
.rtl\\:tw-right-1:where([dir="rtl"], [dir="rtl"] *) {
  right: 0.25rem;
}
.rtl\\:tw-right-1\\.5:where([dir="rtl"], [dir="rtl"] *) {
  right: 0.375rem;
}
.rtl\\:tw-right-2:where([dir="rtl"], [dir="rtl"] *) {
  right: 0.5rem;
}
.rtl\\:tw-right-3:where([dir="rtl"], [dir="rtl"] *) {
  right: 0.75rem;
}
.rtl\\:tw-right-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  right: unset;
}
.rtl\\:tw-right-auto:where([dir="rtl"], [dir="rtl"] *) {
  right: auto;
}
.rtl\\:tw-ml-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.5rem;
}
.rtl\\:tw-ml-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: unset;
}
.rtl\\:tw-mr-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0.5rem;
}
.rtl\\:tw-mr-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: unset;
}
.rtl\\:tw-origin-top-right:where([dir="rtl"], [dir="rtl"] *) {
  transform-origin: top right;
}
.rtl\\:tw--rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:tw-space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
.rtl\\:tw-pl-2:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 0.5rem;
}
.rtl\\:tw-pl-6:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 1.5rem;
}
.rtl\\:tw-pr-0:where([dir="rtl"], [dir="rtl"] *) {
  padding-right: 0px;
}
.rtl\\:tw-pr-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  padding-right: unset;
}
.rtl\\:tw-text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
.rtl\\:after\\:tw-ml-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  margin-left: unset;
}
.rtl\\:after\\:tw-mr-0:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  margin-right: 0px;
}
.rtl\\:after\\:tw-mr-0\\.5:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  margin-right: 0.125rem;
}
.rtl\\:first\\:tw-rounded-l-\\[unset\\]:first-child:where([dir="rtl"], [dir="rtl"] *) {
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
}
.rtl\\:first\\:tw-rounded-r-lg:first-child:where([dir="rtl"], [dir="rtl"] *) {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rtl\\:first\\:before\\:tw-rounded-l-\\[unset\\]:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
}
.rtl\\:first\\:before\\:tw-rounded-r-lg:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rtl\\:last\\:tw-rounded-l-lg:last-child:where([dir="rtl"], [dir="rtl"] *) {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rtl\\:last\\:tw-rounded-r-\\[unset\\]:last-child:where([dir="rtl"], [dir="rtl"] *) {
  border-top-right-radius: unset;
  border-bottom-right-radius: unset;
}
.rtl\\:last\\:before\\:tw-rounded-l-lg:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rtl\\:last\\:before\\:tw-rounded-r-\\[unset\\]:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-right-radius: unset;
  border-bottom-right-radius: unset;
}
.rtl\\:data-\\[focus-visible\\=true\\]\\:tw-translate-x-3[data-focus-visible=true]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[hover\\=true\\]\\:tw-translate-x-3[data-hover=true]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:data-\\[open\\=true\\]\\:tw--rotate-90[data-open=true]:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-group[data-filled=true] .rtl\\:group-data-\\[filled\\=true\\]\\:tw-left-\\[unset\\]:where([dir="rtl"], [dir="rtl"] *) {
  left: unset;
}
.tw-group[data-filled=true] .rtl\\:group-data-\\[filled\\=true\\]\\:tw-right-0:where([dir="rtl"], [dir="rtl"] *) {
  right: 0px;
}
.tw-group[data-selected=true] .rtl\\:group-data-\\[selected\\=true\\]\\:tw-ml-0:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0px;
}
.tw-group[data-selected=true] .rtl\\:group-data-\\[selected\\=true\\]\\:tw-mr-4:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 1rem;
}
.tw-group[data-selected=true] .rtl\\:group-data-\\[selected\\=true\\]\\:tw-mr-5:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 1.25rem;
}
.tw-group[data-selected=true] .rtl\\:group-data-\\[selected\\=true\\]\\:tw-mr-6:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 1.5rem;
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:rtl\\:first\\:before\\:tw-rounded-tl-\\[unset\\]:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-left-radius: unset;
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:rtl\\:first\\:before\\:tw-rounded-tr-lg:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-right-radius: 0.5rem;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:rtl\\:first\\:before\\:tw-rounded-bl-\\[unset\\]:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-bottom-left-radius: unset;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:rtl\\:first\\:before\\:tw-rounded-br-lg:first-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-bottom-right-radius: 0.5rem;
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:rtl\\:last\\:before\\:tw-rounded-tl-lg:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-left-radius: 0.5rem;
}
.tw-group[data-first=true] .group-data-\\[first\\=true\\]\\:rtl\\:last\\:before\\:tw-rounded-tr-\\[unset\\]:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-top-right-radius: unset;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:rtl\\:last\\:before\\:tw-rounded-bl-lg:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-bottom-left-radius: 0.5rem;
}
.tw-group[data-last=true] .group-data-\\[last\\=true\\]\\:rtl\\:last\\:before\\:tw-rounded-br-\\[unset\\]:last-child:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  border-bottom-right-radius: unset;
}
@media (prefers-color-scheme: dark) {

  .dark\\:tw-bg-background {
    background-color: hsl(var(--background));
  }

  .dark\\:tw-bg-background\\/20 {
    background-color: hsl(var(--background) / 0.2);
  }

  .dark\\:tw-bg-content2 {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-content2) / var(--coreui-content2-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:tw-bg-default {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-default) / var(--coreui-default-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:tw-bg-transparent {
    background-color: transparent;
  }

  .dark\\:tw-text-danger-500 {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:tw-text-success {
    --tw-text-opacity: 1;
    color: rgb(3 152 85 / var(--tw-text-opacity));
  }

  .dark\\:tw-text-warning {
    --tw-text-opacity: 1;
    color: rgb(220 104 3 / var(--tw-text-opacity));
  }

  .dark\\:placeholder\\:tw-text-danger-500::placeholder {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:placeholder\\:tw-text-success::placeholder {
    --tw-text-opacity: 1;
    color: rgb(3 152 85 / var(--tw-text-opacity));
  }

  .dark\\:placeholder\\:tw-text-warning::placeholder {
    --tw-text-opacity: 1;
    color: rgb(220 104 3 / var(--tw-text-opacity));
  }

  .dark\\:before\\:tw-via-default-700\\/10::before {
    content: var(--tw-content);
    --tw-gradient-to: hsl(var(--coreui-default-700) / 0)  var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--coreui-default-700) / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
  }

  .dark\\:after\\:tw-bg-content2::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-content2) / var(--coreui-content2-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:focus\\:tw-bg-danger-400\\/20:focus {
    background-color: hsl(var(--coreui-danger-400) / 0.2);
  }

  .dark\\:focus\\:tw-bg-success-400\\/20:focus {
    background-color: hsl(var(--coreui-success-400) / 0.2);
  }

  .dark\\:focus\\:tw-bg-warning-400\\/20:focus {
    background-color: hsl(var(--coreui-warning-400) / 0.2);
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-bg-content2[data-hover=true] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-content2) / var(--coreui-content2-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-bg-danger-50[data-hover=true] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-danger-50) / var(--coreui-danger-50-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-bg-success-50[data-hover=true] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-success-50) / var(--coreui-success-50-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-bg-warning-50[data-hover=true] {
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-warning-50) / var(--coreui-warning-50-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-danger[data-hover=true][data-selected=true] {
    --tw-bg-opacity: 1;
    background-color: rgb(217 45 32 / var(--tw-bg-opacity));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-success[data-hover=true][data-selected=true] {
    --tw-bg-opacity: 1;
    background-color: rgb(3 152 85 / var(--tw-bg-opacity));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-bg-warning[data-hover=true][data-selected=true] {
    --tw-bg-opacity: 1;
    background-color: rgb(220 104 3 / var(--tw-bg-opacity));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-text-danger-500[data-hover=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-text-success-500[data-hover=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-success-500) / var(--coreui-success-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[hover\\=true\\]\\:tw-text-warning-500[data-hover=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-warning-500) / var(--coreui-warning-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-danger-foreground[data-hover=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-danger-foreground) / var(--coreui-danger-foreground-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-success-foreground[data-hover=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[hover\\=true\\]\\:tw-text-warning-foreground[data-hover=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-warning-foreground) / var(--coreui-warning-foreground-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-500[data-range-selection=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-success-500) / var(--coreui-success-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-end\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-foreground[data-range-selection=true][data-selection-end=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[selection-start\\=true\\]\\:data-\\[range-selection\\=true\\]\\:tw-text-success-foreground[data-range-selection=true][data-selection-start=true][data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-success-foreground) / var(--coreui-success-foreground-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:tw-text-danger-500[data-selected=true] {
    --tw-text-opacity: 1;
    color: hsl(var(--coreui-danger-500) / var(--coreui-danger-500-opacity, var(--tw-text-opacity)));
  }

  .dark\\:data-\\[selected\\=true\\]\\:tw-text-success[data-selected=true] {
    --tw-text-opacity: 1;
    color: rgb(3 152 85 / var(--tw-text-opacity));
  }

  .dark\\:data-\\[selected\\=true\\]\\:tw-text-warning[data-selected=true] {
    --tw-text-opacity: 1;
    color: rgb(220 104 3 / var(--tw-text-opacity));
  }

  .dark\\:data-\\[selected\\=true\\]\\:data-\\[range-selection\\=true\\]\\:before\\:tw-bg-warning-50[data-range-selection=true][data-selected=true]::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: hsl(var(--coreui-warning-50) / var(--coreui-warning-50-opacity, var(--tw-bg-opacity)));
  }

  .dark\\:data-\\[invalid\\=true\\]\\:focus\\:tw-bg-danger-400\\/20:focus[data-invalid=true] {
    background-color: hsl(var(--coreui-danger-400) / 0.2);
  }
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-danger\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-danger {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-default\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-default {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-primary\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-primary {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-secondary\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-secondary {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-success\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-success {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\+\\.tw-border-medium\\.tw-border-warning\\]\\:tw-ms-\\[calc\\(theme\\(borderWidth\\.medium\\)\\*-1\\)\\]+.tw-border-medium.tw-border-warning {
  margin-inline-start: calc(var(--coreui-border-width-medium) * -1);
}
.\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\]\\:tw-rounded-none:not(:first-child):not(:last-child) {
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-child\\)\\]\\:tw--ml-1:not(:first-child) {
  margin-left: -0.25rem;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\:not\\(\\:last-of-type\\)\\]\\:tw-rounded-none:not(:first-of-type):not(:last-of-type) {
  border-radius: 0px;
}
.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:tw-ml-\\[calc\\(theme\\(borderWidth\\.2\\)\\*-1\\)\\]:not(:first-of-type) {
  margin-left: calc(2px * -1);
}
.\\[\\&\\>\\*\\]\\:tw-relative>* {
  position: relative;
}
.\\[\\&\\>svg\\]\\:tw-max-w-\\[theme\\(spacing\\.8\\)\\]>svg {
  max-width: 2rem;
}
.\\[\\&\\>tr\\]\\:first\\:tw-rounded-lg:first-child>tr {
  border-radius: 0.5rem;
}
.\\[\\&\\>tr\\]\\:first\\:tw-shadow-small:first-child>tr {
  --tw-shadow: var(--coreui-box-shadow-small);
  --tw-shadow-colored: var(--coreui-box-shadow-small);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&\\[data-hover\\=true\\]\\:not\\(\\[data-active\\=true\\]\\)\\]\\:tw-bg-default-200[data-hover=true]:not([data-active=true]) {
  --tw-bg-opacity: 1;
  background-color: hsl(var(--coreui-default-200) / var(--coreui-default-200-opacity, var(--tw-bg-opacity)));
}
.\\[\\&_\\.chevron-icon\\]\\:tw-flex-none .chevron-icon {
  flex: none;
}
.\\[\\&_\\.chevron-icon\\]\\:tw-rotate-180 .chevron-icon {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\.chevron-icon\\]\\:tw-transition-transform .chevron-icon {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 250ms;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,oCAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,8BAAmB;EAAnB,mCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,oDAAmB;EAAnB,4BAAmB;EAAnB,8BAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,4BAAmB;EAAnB,6DAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,6CAAmB;EAAnB,gCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,mCAAmB;EAAnB,oCAAmB;EAAnB,kCAAmB;EAAnB,uCAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,mDAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,mDAAmB;EAAnB,mDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,oCAAmB;EAAnB,sCAAmB;EAAnB,iDAAmB;EAAnB,wCAAmB;EAAnB,mCAAmB;EAAnB,qDAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,kIAAmB;EAAnB,oIAAmB;EAAnB,oIAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4BAAmB;EAAnB,qCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,yCAAmB;EAAnB,oCAAmB;EAAnB,qCAAmB;EAAnB,8CAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,8BAAmB;EAAnB,gCAAmB;EAAnB,yCAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,mCAAmB;EAAnB,2CAAmB;EAAnB,kCAAmB;EAAnB,8CAAmB;EAAnB,kCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,sCAAmB;EAAnB,mCAAmB;EAAnB,sCAAmB;EAAnB,iCAAmB;EAAnB,sCAAmB;EAAnB,kCAAmB;EAAnB,kDAAmB;EAAnB,oDAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,oDAAmB;EAAnB,0CAAmB;EAAnB,0CAAmB;EAAnB,sDAAmB;EAAnB,sDAAmB;EAAnB,wCAAmB;EAAnB,sCAAmB;EAAnB,gDAAmB;EAAnB,uCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,yCAAmB;EAAnB,wCAAmB;EAAnB,wCAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,sDAAmB;EAAnB,yCAAmB;EAAnB,qDAAmB;EAAnB,sDAAmB;EAAnB,oCAAmB;EAAnB,kDAAmB;EAAnB,kDAAmB;EAAnB,mDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,qDAAmB;EAAnB,oCAAmB;EAAnB,gDAAmB;EAAnB,qCAAmB;EAAnB,oDAAmB;EAAnB,yCAAmB;EAAnB,sCAAmB;EAAnB,qDAAmB;EAAnB,mCAAmB;EAAnB,wCAAmB;EAAnB,iDAAmB;EAAnB,sCAAmB;EAAnB,qCAAmB;EAAnB,qCAAmB;EAAnB,iDAAmB;EAAnB,4BAAmB;EAAnB,6BAAmB;EAAnB,gCAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,kCAAmB;EAAnB,+BAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,mCAAmB;EAAnB,0BAAmB;EAAnB,4BAAmB;EAAnB,2BAAmB;EAAnB,gCAAmB;EAAnB,iCAAmB;EAAnB,gCAAmB;EAAnB,8IAAmB;EAAnB,iJAAmB;EAAnB,iJAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wGAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uHAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gIAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,qBAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAFnB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,uBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;;EAAA;IAAA,0BAEoB;IAFpB;EAEoB;AAAA;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,gEAEoB;EAFpB,+DAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,iFAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,2CAEoB;EAFpB,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+FAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,4BAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,gBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,0BAEoB;EAFpB,gCAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,yBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,gBAEoB;EAFpB,gBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,yCAEoB;EAFpB,uDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,2CAEoB;EAFpB,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,wBAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,gBAEoB;EAFpB;AAEoB;AAFpB;EAAA,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+BAEoB;EAFpB,gCAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,0BAEoB;EAFpB,gCAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,2BAEoB;EAFpB,gCAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,uCAEoB;EAFpB,gCAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,iCAEoB;EAFpB;AAEoB;AAFpB;EAAA,qDAEoB;EAFpB;AAEoB;AAFpB;EAAA,sDAEoB;EAFpB;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,qDAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,oDAEoB;EAFpB;AAEoB;AAFpB;EAAA,4BAEoB;EAFpB;AAEoB;AAFpB;EAAA,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,4BAEoB;EAFpB;AAEoB;AAFpB;EAAA,2BAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,2GAEoB;EAFpB,yGAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0CAEoB;EAFpB,uDAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,4CAEoB;EAFpB,oDAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,qBAEoB;EAFpB;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,eAEoB;EAFpB,eAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,6EAEoB;EAFpB,iGAEoB;EAFpB;AAEoB;AAFpB;EAAA,+EAEoB;EAFpB,mGAEoB;EAFpB;AAEoB;AAFpB;EAAA,6EAEoB;EAFpB,iGAEoB;EAFpB;AAEoB;AAFpB;EAAA,6EAEoB;EAFpB,iGAEoB;EAFpB;AAEoB;AAFpB;EAAA,6EAEoB;EAFpB,iGAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,+CAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB,+QAEoB;UAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,+FAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,+FAEoB;EAFpB,wDAEoB;EAFpB;AAEoB;AAFpB;EAAA,wBAEoB;EAFpB,qBAEoB;AAAA;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,eAEoB;EAFpB,eAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,iBAEoB;EAFpB,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA,sCAEoB;EAFpB;AAEoB;AAFpB;EAAA,uCAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,iFAEoB;EAFpB;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,oHAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,oHAEoB;EAFpB;AAEoB;AAFpB;EAAA,+EAEoB;EAFpB;AAEoB;AAFpB;EAAA,+EAEoB;EAFpB;AAEoB;AAFpB;EAAA,mHAEoB;EAFpB;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,iFAEoB;EAFpB;AAEoB;AAFpB;EAAA,kFAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,oHAEoB;EAFpB;AAEoB;AAFpB;EAAA,gFAEoB;EAFpB;AAEoB;AAFpB;EAAA,oHAEoB;EAFpB;AAEoB;AAFpB;EAAA,+EAEoB;EAFpB;AAEoB;AAFpB;EAAA,+EAEoB;EAFpB;AAEoB;AAFpB;EAAA,mHAEoB;EAFpB;AAEoB;AAFpB;EAAA,yBAEoB;EAFpB;AAEoB;AAFpB;EAAA,eAEoB;EAFpB,eAEoB;EAFpB;AAEoB;AAFpB;EAAA,gBAEoB;EAFpB,gBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,iBAEoB;EAFpB,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,eAEoB;EAFpB,eAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,2GAEoB;EAFpB,yGAEoB;EAFpB;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,qBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,qBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,eAEoB;EAFpB,eAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,iBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,sBAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;;EAAA;IAAA;EAEoB;;EAFpB;IAAA,0BAEoB;IAFpB;EAEoB;AAAA;AAFpB;;EAAA;IAAA,gBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,mBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,eAEoB;IAFpB;EAEoB;;EAFpB;IAAA,gBAEoB;IAFpB;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;AAAA;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,oBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,6BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,+BAEoB;EAFpB;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB,8BAEoB;EAFpB;AAEoB;AAFpB;EAAA,yBAEoB;EAFpB;AAEoB;AAFpB;EAAA,yBAEoB;EAFpB;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;EAAA,0BAEoB;EAFpB;AAEoB;AAFpB;;EAAA;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,0BAEoB;IAFpB,oFAEoB;IAFpB;EAEoB;;EAFpB;IAAA,0BAEoB;IAFpB,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,oBAEoB;IAFpB;EAEoB;;EAFpB;IAAA,0BAEoB;IAFpB,kBAEoB;IAFpB;EAEoB;;EAFpB;IAAA;EAEoB;AAAA;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,2CAEoB;EAFpB,mDAEoB;EAFpB;AAEoB;AAFpB;EAAA,kBAEoB;EAFpB;AAEoB;AAFpB;EAAA;AAEoB;AAFpB;EAAA,mBAEoB;EAFpB;AAEoB;AAFpB;EAAA,8BAEoB;EAFpB,wDAEoB;EAFpB;AAEoB","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
